export const HospitalData = [
  {
    name: "Peking Union Medical College Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "110000",
    pname: "Beijing Municipality",
    adcode: "110101",
    adname: "Dongcheng District",
    citycode: "010",
    cityname: "Beijing Municipality",
    typecode: "090101",
    id: "B000A82Z2N",
    position: ["116.415768", "39.912682"],
  },
  {
    name: "Beijing Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "110000",
    pname: "Beijing Municipality",
    adcode: "110101",
    adname: "Dongcheng District",
    citycode: "010",
    cityname: "Beijing Municipality",
    typecode: "090101",
    id: "B000A52E0B",
    position: ["116.415057", "39.903772"],
  },
  {
    name: "China-Japan Friendship Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "110000",
    pname: "Beijing Municipality",
    adcode: "110105",
    adname: "Chaoyang District",
    citycode: "010",
    cityname: "Beijing Municipality",
    typecode: "090101",
    id: "B000A8370S",
    position: ["116.426883", "39.974097"],
  },
  {
    name: "Fu Wai Hospital, Chinese Academy of Medical Sciences",
    type: "Level 3A",
    level: "Specialist hospitals (cardiovascular)",
    parent: "",
    pcode: "110000",
    pname: "Beijing Municipality",
    adcode: "110102",
    adname: "Xicheng District",
    citycode: "010",
    cityname: "Beijing Municipality",
    typecode: "090200",
    id: "B000A87GVW",
    position: ["116.351313", "39.925289"],
  },
  {
    name: "Peking University First Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "110000",
    pname: "Beijing Municipality",
    adcode: "110102",
    adname: "Xicheng District",
    citycode: "010",
    cityname: "Beijing Municipality",
    typecode: "090101",
    id: "B000A7CNNE",
    position: ["116.380745", "39.931911"],
  },
  {
    name: "Peking University People's Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "110000",
    pname: "Beijing Municipality",
    adcode: "110102",
    adname: "Xicheng District",
    citycode: "010",
    cityname: "Beijing Municipality",
    typecode: "090101",
    id: "B000A5BA25",
    position: ["116.354215", "39.936961"],
  },
  {
    name: "Third Hospital of Peking University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "110000",
    pname: "Beijing Municipality",
    adcode: "110108",
    adname: "Haidian District",
    citycode: "010",
    cityname: "Beijing Municipality",
    typecode: "090101",
    id: "B000A7CGSS",
    Position: ["116.360010", "39.982728"],
  },
  {
    name: "Peking University International Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "B000A887DZ",
    pcode: "110000",
    pname: "Beijing Municipality",
    adcode: "110114",
    adname: "Changping District",
    citycode: "010",
    cityname: "Beijing Municipality",
    typecode: "090100",
    id: "B000A9Q0A3",
    Position: ["116.263513", "40.101167"],
  },
  {
    name: "Xuanwu Hospital of Capital Medical University",
    type: "Level 3A",
    level: "General hospitals (with emphasis on neuroscience, etc.)",
    parent: "B000A844ET",
    pcode: "110000",
    pname: "Beijing Municipality",
    adcode: "110102",
    adname: "Xicheng District",
    citycode: "010",
    cityname: "Beijing Municipality",
    typecode: "090101",
    id: "B000A3EA6A",
    position: ["116.362275", "39.891298"],
  },
  {
    name: "Beijing Chaoyang Hospital of Capital Medical University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "110000",
    pname: "Beijing Municipality",
    adcode: "110105",
    adname: "Chaoyang District",
    citycode: "010",
    cityname: "Beijing Municipality",
    typecode: "090101",
    id: "B000A845NT",
    position: ["116.453397", "39.925878"],
  },
  {
    name: "Beijing Anzhen Hospital of Capital Medical University",
    type: "Level 3A",
    level: "General hospitals (with a clear cardiovascular advantage)",
    parent: "",
    pcode: "110000",
    pname: "Beijing Municipality",
    adcode: "110105",
    adname: "Chaoyang District",
    citycode: "010",
    cityname: "Beijing Municipality",
    typecode: "090101",
    id: "B0FFFVGQPU",
    position: ["116.403379", "39.973153"],
  },
  {
    name: "Beijing Friendship Hospital of Capital Medical University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "110000",
    pname: "Beijing Municipality",
    adcode: "110102",
    adname: "Xicheng District",
    citycode: "010",
    cityname: "Beijing Municipality",
    typecode: "090101",
    id: "B000A11DA0",
    position: ["116.392125", "39.885153"],
  },
  {
    name: "Beijing You'an Hospital affiliated with Capital Medical University",
    type: "Level 3A",
    level: "Specialist hospitals (infectious diseases such as liver disease)",
    parent: "",
    pcode: "110000",
    pname: "Beijing Municipality",
    adcode: "110106",
    adname: "Fengtai District",
    citycode: "010",
    cityname: "Beijing Municipality",
    typecode: "090101",
    id: "B0FFF33T81",
    position: ["116.355761", "39.866660"],
  },
  {
    name: "Beijing Tsinghua Changgeng Hospital, Tsinghua University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "110000",
    pname: "Beijing Municipality",
    adcode: "110114",
    adname: "Changping District",
    citycode: "010",
    cityname: "Beijing Municipality",
    typecode: "090100",
    id: "B0FFF4BCKE",
    position: ["116.414943", "40.072551"],
  },
  {
    name: "General Hospital of the Chinese People's Liberation Army",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "110000",
    pname: "Beijing Municipality",
    adcode: "110108",
    adname: "Haidian District",
    citycode: "010",
    cityname: "Beijing Municipality",
    typecode: "090101",
    id: "B000A9DPJ4",
    Position: ["116.276578", "39.904572"],
  },
  {
    name: "Chinese People's Liberation Army Air Force Centre for Specialty Medicine",
    type: "Level 3A",
    level: "General Hospital (Air Force Speciality Related Medicine)",
    parent: "B000A8VUX1",
    pcode: "110000",
    pname: "Beijing Municipality",
    adcode: "110108",
    adname: "Haidian District",
    citycode: "010",
    cityname: "Beijing Municipality",
    typecode: "090101",
    id: "B0FFLHMWBQ",
    position: ["116.302098", "39.920315"],
  },
  {
    name: "Chinese People's Liberation Army Rocket Force Specialty Medical Centre",
    type: "Level 3A",
    level: "General Hospital (Rocket Force Speciality Related Medicine)",
    parent: "",
    pcode: "110000",
    pname: "Beijing Municipality",
    adcode: "110102",
    adname: "Xicheng District",
    citycode: "010",
    cityname: "Beijing Municipality",
    typecode: "090101",
    id: "B0FFJXXE78",
    position: ["116.372456", "39.956684"],
  },
  {
    name: "Tianjin First Central Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "120000",
    pname: "Tianjin",
    adcode: "120104",
    adname: "Nankai District",
    citycode: "022",
    cityname: "Tianjin",
    typecode: "090101",
    id: "B0016063Z3",
    position: ["117.151896", "39.101076"],
  },
  {
    name: "Tianjin Medical University General Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "120000",
    pname: "Tianjin",
    adcode: "120101",
    adname: "Peace District",
    citycode: "022",
    cityname: "Tianjin",
    typecode: "090101",
    id: "B00160DW6J",
    position: ["117.184610", "39.117381"],
  },
  {
    name: "TEDA International Cardiovascular Disease Hospital",
    type: "Level 3A",
    level: "Specialist hospitals (cardiovascular)",
    parent: "",
    pcode: "120000",
    pname: "Tianjin",
    adcode: "120116",
    adname: "Binhai New Area",
    citycode: "022",
    cityname: "Tianjin",
    typecode: "100100",
    id: "B0FFGIA3BA",
    position: ["117.701087", "39.032254"],
  },
  {
    name: "Tianjin Chest Hospital",
    type: "Level 3A",
    level: "Specialist Hospital (Cardiothoracic Diseases)",
    parent: "",
    pcode: "120000",
    pname: "Tianjin",
    adcode: "120101",
    adname: "Peace District",
    citycode: "022",
    cityname: "Tianjin",
    typecode: "190000",
    id: "B0FFI8O0ZH",
    position: ["117.196951", "39.115886"],
  },
  {
    name: "The Second Hospital of Hebei Medical University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "130000",
    pname: "Hebei Province",
    adcode: "130105",
    adname: "Xinhua District",
    citycode: "0311",
    cityname: "Shijiazhuang",
    typecode: "090101",
    id: "B0137063F3",
    Position: ["114.482117", "38.058064"],
  },
  {
    name: "The Third Hospital of Hebei Medical University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "130000",
    pname: "Hebei Province",
    adcode: "130104",
    adname: "Qiaoxi District",
    citycode: "0311",
    cityname: "Shijiazhuang",
    typecode: "090101",
    id: "B0137028B6",
    Position: ["114.467980", "38.041085"],
  },
  {
    name: "Beidaihe Rehabilitation and Nursing Centre of the Joint Logistics Support Force of the Chinese People's Liberation Army",
    type: "Level 3A",
    level:
      "sanatoriums and rehabilitation institutions (with some medical capacity)",
    parent: "",
    pcode: "130000",
    pname: "Hebei Province",
    adcode: "130304",
    adname: "Beidaihe District",
    citycode: "0335",
    cityname: "Qinhuangdao City",
    typecode: "080402",
    id: "B0FFHWMUUK",
    position: ["119.436487", "39.807535"],
  },
  {
    name: "Shanxi Provincial People's Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "140000",
    pname: "Shanxi Province",
    adcode: "140106",
    adname: "Yingze District",
    citycode: "0351",
    cityname: "Taiyuan",
    typecode: "190301",
    id: "BZCNP101UF",
    position: ["112.580674", "37.845995"],
  },
  {
    name: "Shanxi Second People's Hospital",
    type: "Level 3A",
    level:
      "General hospitals (may focus on some specialities such as nephrology)",
    parent: "",
    pcode: "140000",
    pname: "Shanxi Province",
    adcode: "140106",
    adname: "Yingze District",
    citycode: "0351",
    cityname: "Taiyuan",
    typecode: "090200",
    id: "B015F008D1",
    position: ["112.556525", "37.843484"],
  },
  {
    name: "The First Hospital of Shanxi Medical University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "140000",
    pname: "Shanxi Province",
    adcode: "140106",
    adname: "Yingze District",
    citycode: "0351",
    cityname: "Taiyuan",
    typecode: "090101",
    id: "B015F0038D",
    position: ["112.555397", "37.853330"],
  },
  {
    name: "Datong Third People's Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "140000",
    pname: "Shanxi Province",
    adcode: "140213",
    adname: "Pingcheng District",
    citycode: "0352",
    cityname: "Datong",
    typecode: "090101",
    id: "B016000B0U",
    Position: ["113.287731", "40.075053"],
  },
  {
    name: "Shanxi Baiqiu'en Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "140000",
    pname: "Shanxi Province",
    adcode: "140105",
    adname: "Xiaodian District",
    citycode: "0351",
    cityname: "Taiyuan",
    typecode: "090101",
    id: "B0FFKYMJBB",
    position: ["112.555225", "37.777302"],
  },
  {
    name: "Shanxi Provincial Cardiovascular Disease Hospital",
    type: "Level 3A",
    level: "Specialist hospitals (cardiovascular)",
    parent: "",
    pcode: "140000",
    pname: "Shanxi Province",
    adcode: "140109",
    adname: "Wan Berlin District",
    citycode: "0351",
    cityname: "Taiyuan",
    typecode: "090205",
    id: "B015F0I8LN",
    position: ["112.525249", "37.871733"],
  },
  {
    name: "Inner Mongolia Baogang Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "150000",
    pname: "Inner Mongolia Autonomous Region",
    adcode: "150203",
    adname: "Kundulun District",
    citycode: "0472",
    cityname: "Baotou",
    typecode: "090101",
    id: "B01D80108C",
    position: ["109.824671", "40.652117"],
  },
  {
    name: "Affiliated Hospital of Inner Mongolia Medical University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "150000",
    pname: "Inner Mongolia Autonomous Region",
    adcode: "150103",
    adname: "Hui Min District",
    citycode: "0471",
    cityname: "Hohhot",
    typecode: "090101",
    id: "B01D7023H7",
    position: ["111.657528", "40.820503"],
  },
  {
    name: "The First Hospital of China Medical University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "210000",
    pname: "Liaoning Province",
    adcode: "210102",
    adname: "Peace District",
    citycode: "024",
    cityname: "Shenyang City",
    typecode: "090101",
    id: "B00180CWQO",
    position: ["123.411350", "41.795344"],
  },
  {
    name: "The Second Hospital of Dalian Medical University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "210000",
    pname: "Liaoning Province",
    adcode: "210204",
    adname: "Shahekou District",
    citycode: "0411",
    cityname: "Dalian",
    typecode: "090101",
    id: "B019B0AOZE",
    position: ["121.570231", "38.882761"],
  },
  {
    name: "Dalian Friendship Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "210000",
    pname: "Liaoning Province",
    adcode: "210202",
    adname: "Middle Mountain District",
    citycode: "0411",
    cityname: "Dalian",
    typecode: "090101",
    id: "B019B111J1",
    Position: ["121.657033", "38.921100"],
  },
  {
    name: "鞍钢集团总医院",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "210000",
    pname: "Liaoning Province",
    adcode: "210302",
    adname: "Tiedong District",
    citycode: "0412",
    cityname: "Anshan",
    typecode: "090101",
    id: "B0FFF5TZTT",
    Position: ["123.011252", "41.120319"],
  },
  {
    name: "General Hospital of the Northern War Area of the Chinese People's Liberation Army",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "210000",
    pname: "Liaoning Province",
    adcode: "210103",
    adname: "Shenhe District",
    citycode: "024",
    cityname: "Shenyang City",
    typecode: "090101",
    id: "B0FFJU0NYC",
    Position: ["123.440500", "41.769683"],
  },
  {
    name: "Chinese People's Liberation Army Air Force Hospital of the Northern Theatre",
    type: "Level 3A",
    level: "General Hospital (Air Force Speciality Related Medicine)",
    parent: "",
    pcode: "210000",
    pname: "Liaoning Province",
    adcode: "210104",
    adname: "Greater East Side",
    citycode: "024",
    cityname: "Shenyang City",
    typecode: "090207",
    id: "B001802FB0",
    position: ["123.472908", "41.793921"],
  },
  {
    name: "Baiqiu'en First Hospital of Jilin University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "B01AF06SEY",
    pcode: "220000",
    pname: "Jilin Province",
    adcode: "220104",
    adname: "Chaoyang District",
    citycode: "0431",
    cityname: "Changchun",
    typecode: "090101",
    id: "B01AF127AE",
    Position: ["125.304855", "43.877282"],
  },
  {
    name: "The First Hospital of Harbin Medical University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "B01C30JIUR",
    pcode: "230000",
    pname: "Heilongjiang Province",
    adcode: "230103",
    adname: "Nangang District",
    citycode: "0451",
    cityname: "Harbin",
    typecode: "150904",
    id: "B01C30JIWH",
    position: ["126.650518", "45.764741"],
  },
  {
    name: "The Second Hospital of Harbin Medical University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "B01C30JJ8F",
    pcode: "230000",
    pname: "Heilongjiang Province",
    adcode: "230103",
    adname: "Nangang District",
    citycode: "0451",
    cityname: "Harbin",
    typecode: "050100",
    id: "B0FFIQS9N6",
    position: ["126.619554", "45.694548"],
  },
  {
    name: "Zhongshan Hospital of Fudan University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "310000",
    pname: "Shanghai",
    adcode: "310104",
    adname: "Xuhui District",
    citycode: "021",
    cityname: "Shanghai Municipality",
    typecode: "090101",
    id: "B00156TKFX",
    position: ["121.454965", "31.197318"],
  },
  {
    name: "Huashan Hospital of Fudan University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "310000",
    pname: "Shanghai",
    adcode: "310106",
    adname: "Jing'an District",
    citycode: "021",
    cityname: "Shanghai Municipality",
    typecode: "090101",
    id: "B00155KT4W",
    position: ["121.442932", "31.216111"],
  },
  {
    name: "Paediatric Hospital Affiliated to Fudan University",
    type: "Level 3A",
    level: "Specialist hospitals (paediatrics)",
    parent: "",
    pcode: "310000",
    pname: "Shanghai",
    adcode: "310112",
    adname: "Minhang District",
    citycode: "021",
    cityname: "Shanghai Municipality",
    typecode: "090200",
    id: "B00155KP0U",
    position: ["121.394971", "31.139147"],
  },
  {
    name: "Shanghai First People's Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "310000",
    pname: "Shanghai",
    adcode: "310109",
    adname: "Hongkou District",
    citycode: "021",
    cityname: "Shanghai Municipality",
    typecode: "141300",
    id: "B00153A582",
    position: ["121.489273", "31.253352"],
  },
  {
    name: "Ruijin Hospital of Shanghai Jiaotong University School of Medicine",
    type: "Level 3A",
    level: "General Hospital",
    parent: "B00156QHJ2",
    pcode: "310000",
    pname: "Shanghai",
    adcode: "310101",
    adname: "Huangpu District",
    citycode: "021",
    cityname: "Shanghai Municipality",
    typecode: "090101",
    id: "B00155L9T9",
    position: ["121.467617", "31.211761"],
  },
  {
    name: "Shanghai Jiaotong University Medical College Affiliated Xinhua Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "B00156QHJ2",
    pcode: "310000",
    pname: "Shanghai",
    adcode: "310110",
    adname: "Yangpu District",
    citycode: "021",
    cityname: "Shanghai Municipality",
    typecode: "090101",
    id: "B00155KEIX",
    position: ["121.517681", "31.273130"],
  },
  {
    name: "Renji Hospital, Shanghai Jiaotong University School of Medicine",
    type: "Level 3A",
    level: "General Hospital",
    parent: "B00155L1WO",
    pcode: "310000",
    pname: "Shanghai",
    adcode: "310101",
    adname: "Huangpu District",
    citycode: "021",
    cityname: "Shanghai Municipality",
    typecode: "090101",
    id: "B001570WJ3",
    position: ["121.484270", "31.233971"],
  },
  {
    name: "Shanghai Children's Medical Centre, Shanghai Jiao Tong University School of Medicine",
    type: "Level 3A",
    level: "Specialist hospitals (paediatrics)",
    parent: "",
    pcode: "310000",
    pname: "Shanghai",
    adcode: "310115",
    adname: "Pudong New Area",
    citycode: "021",
    cityname: "Shanghai Municipality",
    typecode: "090101",
    id: "B0FFFY3PJG",
    position: ["121.522661", "31.205738"],
  },
  {
    name: "Shanghai Chest Hospital",
    type: "Level 3A",
    level: "Specialist Hospital (Cardiothoracic Diseases)",
    parent: "",
    pcode: "310000",
    pname: "Shanghai",
    adcode: "310104",
    adname: "Xuhui District",
    citycode: "021",
    cityname: "Shanghai Municipality",
    typecode: "090205",
    id: "B0G0CUYIP5",
    position: ["121.426043", "31.197695"],
  },
  {
    name: "Shanghai Lung Hospital",
    type: "Level 3A",
    level: "Specialist hospitals (lung diseases)",
    parent: "",
    pcode: "310000",
    pname: "Shanghai",
    adcode: "310110",
    adname: "Yangpu District",
    citycode: "021",
    cityname: "Shanghai Municipality",
    typecode: "090101",
    id: "B00155E7IJ",
    position: ["121.501899", "31.302544"],
  },
  {
    name: "The First Affiliated Hospital of the Navy Military Medical University of the Chinese People's Liberation Army",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "310000",
    pname: "Shanghai",
    adcode: "310110",
    adname: "Yangpu District",
    citycode: "021",
    cityname: "Shanghai Municipality",
    typecode: "140000",
    id: "B0FFJ597NX",
    position: ["121.529259", "31.306753"],
  },
  {
    name: "The Second Affiliated Hospital of the Navy Military Medical University of the Chinese People's Liberation Army",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "310000",
    pname: "Shanghai",
    adcode: "310115",
    adname: "Pudong New Area",
    citycode: "021",
    cityname: "Shanghai Municipality",
    typecode: "090101",
    id: "B00156YLJ4",
    position: ["121.512572", "31.148012"],
  },
  {
    name: "The Third Affiliated Hospital of the Navy Military Medical University of the Chinese People's Liberation Army",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "310000",
    pname: "Shanghai",
    adcode: "310110",
    adname: "Yangpu District",
    citycode: "021",
    cityname: "Shanghai Municipality",
    typecode: "120302",
    id: "B0FFGB71UO",
    position: ["121.533767", "31.309050"],
  },
  {
    name: "The First Affiliated Hospital of Soochow University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "B0FFL1OLPA",
    pcode: "320000",
    pname: "Jiangsu Province",
    adcode: "320508",
    adname: "Gusu District",
    citycode: "0512",
    cityname: "Suzhou",
    typecode: "050100",
    id: "B0FFFCVC0F",
    position: ["120.634399", "31.304555"],
  },
  {
    name: "Wuxi People's Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "320000",
    pname: "Jiangsu Province",
    adcode: "320213",
    adname: "Liangxi District",
    citycode: "0510",
    cityname: "Wuxi City",
    typecode: "090101",
    id: "B01FE0II5H",
    position: ["120.323368", "31.540592"],
  },
  {
    name: "Changzhou First People's Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "320000",
    pname: "Jiangsu Province",
    adcode: "320402",
    adname: "Tianning District",
    citycode: "0519",
    cityname: "Changzhou City",
    typecode: "090101",
    id: "B020701JQM",
    position: ["119.960866", "31.779492"],
  },
  {
    name: "Nanjing First Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "320000",
    pname: "Jiangsu Province",
    adcode: "320104",
    adname: "Qinhuai District",
    citycode: "025",
    cityname: "Nanjing",
    typecode: "090101",
    id: "B001907W0X",
    Position: ["118.784263", "32.017145"],
  },
  {
    name: "General Hospital of the Eastern Theatre of the Chinese People's Liberation Army",
    type: "Level 3A",
    level: "General Hospital",
    parent: "B0FFJRI5KZ",
    pcode: "320000",
    pname: "Jiangsu Province",
    adcode: "320102",
    adname: "Xuanwu District",
    citycode: "025",
    cityname: "Nanjing",
    typecode: "090101",
    id: "B0FFJRY861",
    position: ["118.808021", "32.040747"],
  },
  {
    name: "The Second Affiliated Hospital of Nanjing Medical University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "320000",
    pname: "Jiangsu Province",
    adcode: "320106",
    adname: "Gulou District",
    citycode: "025",
    cityname: "Nanjing",
    typecode: "090101",
    id: "B00190A90H",
    position: ["118.744998", "32.080323"],
  },
  {
    name: "Affiliated Hospital of Xuzhou Medical University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "320000",
    pname: "Jiangsu Province",
    adcode: "320311",
    adname: "Izumisan-gu",
    citycode: "0516",
    cityname: "Xuzhou",
    typecode: "160104",
    id: "B0FFGX2SW1",
    position: ["117.179368", "34.263154"],
  },
  {
    name: "The First Hospital Affiliated to the Medical College of Zhejiang University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "330000",
    pname: "Zhejiang Province",
    adcode: "330102",
    adname: "Uptown",
    citycode: "0571",
    cityname: "Hangzhou",
    typecode: "090101",
    id: "B023B0929X",
    position: ["120.177825", "30.255920"],
  },
  {
    name: "The Second Affiliated Hospital of Zhejiang University School of Medicine",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "330000",
    pname: "Zhejiang Province",
    adcode: "330102",
    adname: "Uptown",
    citycode: "0571",
    cityname: "Hangzhou",
    typecode: "090101",
    id: "B0FFG8HLTS",
    position: ["120.177439", "30.251172"],
  },
  {
    name: "Run Run Shaw Hospital, Zhejiang University School of Medicine",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "330000",
    pname: "Zhejiang Province",
    adcode: "330102",
    adname: "Uptown",
    citycode: "0571",
    cityname: "Hangzhou",
    typecode: "090101",
    id: "B023B051V6",
    position: ["120.202351", "30.256376"],
  },
  {
    name: "Children's Hospital of Zhejiang University School of Medicine",
    type: "Level 3A",
    level: "Specialist hospitals (paediatrics)",
    parent: "",
    pcode: "330000",
    pname: "Zhejiang Province",
    adcode: "330105",
    adname: "Gongshu District",
    citycode: "0571",
    cityname: "Hangzhou",
    typecode: "090200",
    id: "B023B06XYO",
    position: ["120.165734", "30.260224"],
  },
  {
    name: "Zhejiang Provincial People's Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "B023B0572T",
    pcode: "330000",
    pname: "Zhejiang Province",
    adcode: "330105",
    adname: "Gongshu District",
    citycode: "0571",
    cityname: "Hangzhou",
    typecode: "090101",
    id: "B0HKDUYNP9",
    position: ["120.168551", "30.285243"],
  },
  {
    name: "The First Hospital of Wenzhou Medical University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "330000",
    pname: "Zhejiang Province",
    adcode: "330302",
    adname: "Deer District",
    citycode: "0577",
    cityname: "wenzhou",
    typecode: "090101",
    id: "B024103ZQM",
    Position: ["120.665318", "28.013566"],
  },
  {
    name: "Li Huili East Hospital, Ningbo Medical Centre",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "330000",
    pname: "Zhejiang Province",
    adcode: "330212",
    adname: "yinzhou district",
    citycode: "0574",
    cityname: "Ningbo",
    typecode: "100100",
    id: "B0FFI5SAZM",
    position: ["121.562708", "29.853098"],
  },
  {
    name: "Ningbo Yinzhou District Second Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "330000",
    pname: "Zhejiang Province",
    adcode: "330212",
    adname: "yinzhou district",
    citycode: "0574",
    cityname: "Ningbo",
    typecode: "190301",
    id: "B0FFH5APW9",
    position: ["121.552893", "29.808744"],
  },
  {
    name: "Shulan (Hangzhou) Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "330000",
    pname: "Zhejiang Province",
    adcode: "330105",
    adname: "Gongshu District",
    citycode: "0571",
    cityname: "Hangzhou",
    typecode: "090101",
    id: "B0FFG6IQYR",
    position: ["120.174522", "30.328786"],
  },
  {
    name: "Chinese People's Liberation Army Joint Logistics Force 103rd Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "330000",
    pname: "Zhejiang Province",
    adcode: "330106",
    adname: "Westlake",
    citycode: "0571",
    cityname: "Hangzhou",
    typecode: "120302",
    id: "B0J3MHF2OE",
    position: ["120.116301", "30.246458"],
  },

  {
    name: "The First Hospital Affiliated to the University of Science and Technology of China",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "340000",
    pname: "Anhui Province",
    adcode: "340104",
    adname: "Shushan District",
    citycode: "0551",
    cityname: "Hefei",
    typecode: "090101",
    id: "B022702OL9",
    position: ["117.267662", "31.847151"],
  },
  {
    name: "The First Affiliated Hospital of Anhui Medical University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "340000",
    pname: "Anhui Province",
    adcode: "340104",
    adname: "Shushan District",
    citycode: "0551",
    cityname: "Hefei",
    typecode: "090101",
    id: "B022702OL9",
    position: ["117.267662", "31.847151"],
  },
  {
    name: "The Second Affiliated Hospital of Anhui Medical University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "340000",
    pname: "Anhui Province",
    adcode: "340104",
    adname: "Shushan District",
    citycode: "0551",
    cityname: "Hefei",
    typecode: "090101",
    id: "B02270IHE7",
    position: ["117.212410", "31.790188"],
  },
  {
    name: "The First Affiliated Hospital of Fujian Medical University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "350000",
    pname: "Fujian Province",
    adcode: "350103",
    adname: "Taijiang District",
    citycode: "0591",
    cityname: "Fuzhou",
    typecode: "090101",
    id: "B024F05WSS",
    position: ["119.304419", "26.061337"],
  },
  {
    name: "Union Hospital of Fujian Medical University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "350000",
    pname: "Fujian Province",
    adcode: "350102",
    adname: "Gulou District",
    citycode: "0591",
    cityname: "Fuzhou",
    typecode: "090101",
    id: "B024F01LIN",
    position: ["119.304020", "26.077841"],
  },
  {
    name: "Mengchao Liver and Gallbladder Hospital of Fujian Medical University",
    type: "Level 3A",
    level: "Specialist Hospital (Hepatobiliary Diseases)",
    parent: "B0FFF5WFDJ",
    pcode: "350000",
    pname: "Fujian Province",
    adcode: "350102",
    adname: "Gulou District",
    citycode: "0591",
    cityname: "Fuzhou",
    typecode: "090200",
    id: "B0FFGWONXL",
    position: ["119.279129", "26.085306"],
  },
  {
    name: "Fujian Provincial Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "B024F04VN7",
    pcode: "350000",
    pname: "Fujian Province",
    adcode: "350102",
    adname: "Gulou District",
    citycode: "0591",
    cityname: "Fuzhou",
    typecode: "050100",
    id: "B0GRKU5LSZ",
    position: ["119.299381", "26.084133"],
  },
  {
    name: "Xiamen University Xiang'an Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "350000",
    pname: "Fujian Province",
    adcode: "350213",
    adname: "Xiang'an District",
    citycode: "0592",
    cityname: "Xiamen",
    typecode: "090100",
    id: "B02500QKUL",
    Position: ["118.350162", "24.585555"],
  },
  {
    name: "Zhongshan Hospital of Xiamen University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "350000",
    pname: "Fujian Province",
    adcode: "350203",
    adname: "Siming District",
    citycode: "0592",
    cityname: "Xiamen",
    typecode: "090101",
    id: "B0250007B9",
    position: ["118.097611", "24.471519"],
  },
  {
    name: "The First Affiliated Hospital of Xiamen University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "350000",
    pname: "Fujian Province",
    adcode: "350203",
    adname: "Siming District",
    citycode: "0592",
    cityname: "Xiamen",
    typecode: "090101",
    id: "B025002CF9",
    position: ["118.088180", "24.450940"],
  },
  {
    name: "Chinese People's Liberation Army Joint Logistics Force Ninetieth Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "B0FFJRGU1I",
    pcode: "350000",
    pname: "Fujian Province",
    adcode: "350102",
    adname: "Gulou District",
    citycode: "0591",
    cityname: "Fuzhou",
    typecode: "090101",
    id: "B0FFK1YGP1",
    Position: ["119.280085", "26.092136"],
  },
  {
    name: "Chinese People's Liberation Army Joint Logistics Force 910 Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "350000",
    pname: "Fujian Province",
    adcode: "350502",
    adname: "carp city",
    citycode: "0595",
    cityname: "Quanzhou",
    typecode: "120302",
    id: "B0FFGALDA1",
    position: ["118.596073", "24.911835"],
  },
  {
    name: "Xiamen University Affiliated Cardiovascular Disease Hospital",
    type: "Level 3A",
    level: "Specialist hospitals (cardiovascular)",
    parent: "",
    pcode: "350000",
    pname: "Fujian Province",
    adcode: "350203",
    adname: "Siming District",
    citycode: "0592",
    cityname: "Xiamen",
    typecode: "120201",
    id: "B0FFJVF9IM",
    Position: ["118.100926", "24.472134"],
  },
  {
    name: "Jiangxi Provincial People's Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "360000",
    pname: "Jiangxi Province",
    adcode: "360102",
    adname: "Eastlake",
    citycode: "0791",
    cityname: "Nanchang",
    typecode: "120303",
    id: "B0FFF5OJLQ",
    position: ["115.887725", "28.691942"],
  },
  {
    name: "The First Affiliated Hospital of Nanchang University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "360000",
    pname: "Jiangxi Province",
    adcode: "360102",
    adname: "Eastlake",
    citycode: "0791",
    cityname: "Nanchang",
    typecode: "090101",
    id: "B031702KIL",
    position: ["115.910291", "28.686539"],
  },
  {
    name: "The Second Affiliated Hospital of Nanchang University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "360000",
    pname: "Jiangxi Province",
    adcode: "360102",
    adname: "Eastlake",
    citycode: "0791",
    cityname: "Nanchang",
    typecode: "090101",
    id: "B031702VZZ",
    position: ["115.901957", "28.682490"],
  },
  {
    name: "Shandong University Qilu Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "370000",
    pname: "Shandong Province",
    adcode: "370102",
    adname: "Lixia District",
    citycode: "0531",
    cityname: "Jinan",
    typecode: "090101",
    id: "B02130WZ7F",
    Position: ["117.018773", "36.656637"],
  },
  {
    name: "The Second Hospital of Shandong University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "370000",
    pname: "Shandong Province",
    adcode: "370102",
    adname: "Lixia District",
    citycode: "0531",
    cityname: "Jinan",
    typecode: "090101",
    id: "B02130WZ7F",
    Position: ["117.018773", "36.656637"],
  },
  {
    name: "Shandong Provincial Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "370000",
    pname: "Shandong Province",
    adcode: "370104",
    adname: "locust district",
    citycode: "0531",
    cityname: "Jinan",
    typecode: "080603",
    id: "B0213014FF",
    Position: ["116.982434", "36.657591"],
  },
  {
    name: "Affiliated Hospital of Qingdao University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "370000",
    pname: "Shandong Province",
    adcode: "370202",
    adname: "市南区",
    citycode: "0532",
    cityname: "Qingdao",
    typecode: "090101",
    id: "B021403HO2",
    position: ["120.327228", "36.067916"],
  },
  {
    name: "Shandong Province Qianfoshan Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "370000",
    pname: "Shandong Province",
    adcode: "370102",
    adname: "Lixia District",
    citycode: "0531",
    cityname: "Jinan",
    typecode: "100105",
    id: "B0FFGQ30FC",
    Position: ["117.053823", "36.648165"],
  },
  {
    name: "Yantai Yuhuanding Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "370000",
    pname: "Shandong Province",
    adcode: "370602",
    adname: "chifu",
    citycode: "0535",
    cityname: "Yantai City",
    typecode: "090101",
    id: "B021704X7N",
    position: ["121.389746", "37.535769"],
  },
  {
    name: "Linyi City People's Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "370000",
    pname: "Shandong Province",
    adcode: "371302",
    adname: "Lanshan District",
    citycode: "0539",
    cityname: "Linyi",
    typecode: "090101",
    id: "B021B09FNI",
    Position: ["118.350793", "35.063762"],
  },
  {
    name: "Liaocheng City People's Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "B027B016C9",
    pcode: "370000",
    pname: "Shandong Province",
    adcode: "371502",
    adname: "Dongchangfu District",
    citycode: "0635",
    cityname: "Liaocheng City",
    typecode: "090100",
    id: "B0FFIXE6WT",
    position: ["115.977523", "36.469892"],
  },
  {
    name: "Weifang City People's Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "370000",
    pname: "Shandong Province",
    adcode: "370705",
    adname: "Quiwen District",
    citycode: "0536",
    cityname: "Weifang",
    typecode: "141202",
    id: "B0218030BR",
    position: ["119.129473", "36.701748"],
  },
  {
    name: "Chinese People's Liberation Army Joint Logistics Force No. 960 Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "370000",
    pname: "Shandong Province",
    adcode: "370105",
    adname: "Tianqiao District",
    citycode: "0531",
    cityname: "Jinan",
    typecode: "090101",
    id: "B0FFJXWTMY",
    position: ["116.982558", "36.696924"],
  },
  {
    name: "Chinese People's Liberation Army Joint Command and Guarantee Forces Ninety-seven Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "370000",
    pname: "Shandong Province",
    adcode: "370613",
    adname: "Laysan District",
    citycode: "0535",
    cityname: "Yantai City",
    typecode: "190301",
    id: "B0IA34J80Q",
    position: ["121.443190", "37.514465"],
  },
  {
    name: "Chinese People's Liberation Army Navy Hospital No. 971",
    type: "Level 3A",
    level: "General Hospital",
    parent: "B02140VT8F",
    pcode: "370000",
    pname: "Shandong Province",
    adcode: "370202",
    adname: "市南区",
    citycode: "0532",
    cityname: "Qingdao",
    typecode: "071600",
    id: "B0JG3DWGX3",
    Position: ["120.386284", "36.071360"],
  },
  {
    name: "The First Affiliated Hospital of Zhengzhou University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "410000",
    pname: "Henan Province",
    adcode: "410103",
    adname: "Erqi District",
    citycode: "0371",
    cityname: "Zhengzhou",
    typecode: "090101",
    id: "B0173080HG",
    position: ["113.646042", "34.752734"],
  },
  {
    name: "Henan Provincial People's Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "B01730KBLG",
    pcode: "410000",
    pname: "Henan Province",
    adcode: "410105",
    adname: "Jinshui District",
    citycode: "0371",
    cityname: "Zhengzhou",
    typecode: "061210",
    id: "B0JRFHS5VA",
    position: ["113.681492", "34.771209"],
  },
  {
    name: "Zhengzhou People's Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "B017305KKO",
    pcode: "410000",
    pname: "Henan Province",
    adcode: "410102",
    adname: "Central Plains District",
    citycode: "0371",
    cityname: "Zhengzhou",
    typecode: "090101",
    id: "B0IAJGR305",
    position: ["113.612287", "34.750256"],
  },
  {
    name: "Zhengzhou Seventh People's Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "410000",
    pname: "Henan Province",
    adcode: "410104",
    adname: "Guancheng Huizu District",
    citycode: "0371",
    cityname: "Zhengzhou",
    typecode: "090200",
    id: "B01730K9C6",
    position: ["113.740263", "34.713582"],
  },
  {
    name: "The First Affiliated Hospital of Henan College of Traditional Chinese Medicine",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "410000",
    pname: "Henan Province",
    adcode: "410105",
    adname: "Jinshui District",
    citycode: "0371",
    cityname: "Zhengzhou",
    typecode: "090101",
    id: "B0173046A3",
    position: ["113.674298", "34.759020"],
  },
  {
    name: "Chinese People's Liberation Army Joint Logistics Force 988 Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "410000",
    pname: "Henan Province",
    adcode: "410105",
    adname: "Jinshui District",
    citycode: "0371",
    cityname: "Zhengzhou",
    typecode: "190301",
    id: "B0IA3GLW9P",
    position: ["113.637196", "34.772961"],
  },
  {
    name: "Fuwai Huazhong Cardiovascular Disease Hospital",
    type: "Level 3A",
    level: "Specialist hospitals (cardiovascular)",
    parent: "",
    pcode: "410000",
    pname: "Henan Province",
    adcode: "410105",
    adname: "Jinshui District",
    citycode: "0371",
    cityname: "Zhengzhou",
    typecode: "141203",
    id: "B0173084FO",
    position: ["113.680345", "34.772689"],
  },
  {
    name: "Tongji Hospital, Tongji Medical College, Huazhong University of Science and Technology",
    type: "Level 3A",
    level: "General Hospital",
    parent: "B001B07JBE",
    pcode: "420000",
    pname: "Hubei Province",
    adcode: "420104",
    adname: "qiaokou district",
    citycode: "027",
    cityname: "Wuhan",
    typecode: "090101",
    id: "B0FFGTQYIR",
    position: ["114.262367", "30.579204"],
  },
  {
    name: "Union Hospital of Tongji Medical College, Huazhong University of Science and Technology",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "420000",
    pname: "Hubei Province",
    adcode: "420103",
    adname: "Jianghan District",
    citycode: "027",
    cityname: "Wuhan",
    typecode: "090101",
    id: "B001B0IZPF",
    position: ["114.274723", "30.584057"],
  },
  {
    name: "Wuhan University People's Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "B001B06652",
    pcode: "420000",
    pname: "Hubei Province",
    adcode: "420106",
    adname: "Wuchang District",
    citycode: "027",
    cityname: "Wuhan",
    typecode: "090101",
    id: "B001B1C7BQ",
    position: ["114.300585", "30.535761"],
  },
  {
    name: "Wuhan University Zhongnan Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "420000",
    pname: "Hubei Province",
    adcode: "420111",
    adname: "Hongshan District",
    citycode: "027",
    cityname: "Wuhan",
    typecode: "090100|090200",
    id: "B0FFKCKC2N",
    position: ["114.396585", "30.536372"],
  },
  {
    name: "Dongfeng General Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "420000",
    pname: "Hubei Province",
    adcode: "420303",
    adname: "Zhangwan District",
    citycode: "0719",
    cityname: "Shiyan",
    typecode: "060400|060100",
    id: "B02CF0QCF8",
    Position: ["110.771031", "32.653481"],
  },
  {
    name: "General Hospital of the Central Theatre of the Chinese People's Liberation Army",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "420000",
    pname: "Hubei Province",
    adcode: "420106",
    adname: "Wuchang District",
    citycode: "027",
    cityname: "Wuhan",
    typecode: "090101",
    id: "B0FFJS7ZOP",
    position: ["114.344866", "30.531123"],
  },
  {
    name: "Wuhan Asian Heart Hospital",
    type: "Level 3A",
    level: "Specialist hospitals (cardiovascular)",
    parent: "",
    pcode: "420000",
    pname: "Hubei Province",
    adcode: "420103",
    adname: "Jianghan District",
    citycode: "027",
    cityname: "Wuhan",
    typecode: "120201",
    id: "B001B0JOUU",
    position: ["114.281771", "30.582584"],
  },
  {
    name: "Yichang Central People's Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "420000",
    pname: "Hubei Province",
    adcode: "420503",
    adname: "Wujiagang District",
    citycode: "0717",
    cityname: "Yichang",
    typecode: "090101",
    id: "B0FFFGWCLN",
    position: ["111.306907", "30.684410"],
  },
  {
    name: "Xiangya Hospital of Central South University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "430000",
    pname: "Hunan Province",
    adcode: "430105",
    adname: "Kaifu District",
    citycode: "0731",
    cityname: "Changsha City",
    typecode: "090101",
    id: "B02DB00B1E",
    position: ["112.984047", "28.212209"],
  },
  {
    name: "The Second Xiangya Hospital of Central South University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "430000",
    pname: "Hunan Province",
    adcode: "430102",
    adname: "Furong District",
    citycode: "0731",
    cityname: "Changsha City",
    typecode: "100103",
    id: "B02DB0VBWH",
    position: ["113.027619", "28.184897"],
  },
  {
    name: "Xiangya Third Hospital of Central South University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "430000",
    pname: "Hunan Province",
    adcode: "430104",
    adname: "Yuelu District",
    citycode: "0731",
    cityname: "Changsha City",
    typecode: "090101",
    id: "B02DB02J64",
    position: ["112.944798", "28.220483"],
  },
  {
    name: "Hunan Provincial People's Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "430000",
    pname: "Hunan Province",
    adcode: "430102",
    adname: "Furong District",
    citycode: "0731",
    cityname: "Changsha City",
    typecode: "090101",
    id: "B0H39RU13M",
    position: ["112.981993", "28.190395"],
  },
  {
    name: "Yiyang City Centre Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "430000",
    pname: "Hunan Province",
    adcode: "430903",
    adname: "Heshan District",
    citycode: "0737",
    cityname: "Yiyang City",
    typecode: "090100",
    id: "B02E1001PC",
    position: ["112.354620", "28.570175"],
  },
  {
    name: "Chenzhou First People's Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "430000",
    pname: "Hunan Province",
    adcode: "431002",
    adname: "North Lakes",
    citycode: "0735",
    cityname: "Chenzhou",
    typecode: "141201",
    id: "B02DF007E4",
    position: ["113.022814", "25.792694"],
  },
  {
    name: "The Second Affiliated Hospital of Nanhua University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "430000",
    pname: "Hunan Province",
    adcode: "430407",
    adname: "Stone Drum District",
    citycode: "0734",
    cityname: "Hengyang City",
    typecode: "190301",
    id: "B0IA3ZSFYS",
    position: ["112.606648", "26.896262"],
  },
  {
    name: "Changde First People's Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "430000",
    pname: "Hunan Province",
    adcode: "430702",
    adname: "Wuling District",
    citycode: "0736",
    cityname: "Changde City",
    typecode: "190301",
    id: "B0FFGD4CIX",
    position: ["111.693638", "29.028146"],
  },
  {
    name: "Yueyang No. 1 People's Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "B0HRSLRM6M",
    pcode: "430000",
    pname: "Hunan Province",
    adcode: "430602",
    adname: "Yueyanglou District",
    citycode: "0730",
    cityname: "Yueyang City",
    typecode: "090101",
    id: "B02DA014B2",
    position: ["113.111718", "29.372735"],
  },
  {
    name: "Hunan Children's Hospital",
    type: "Level 3A",
    level: "Specialist hospitals (paediatrics)",
    parent: "",
    pcode: "430000",
    pname: "Hunan Province",
    adcode: "430111",
    adname: "Yuhua District",
    citycode: "0731",
    cityname: "Changsha City",
    typecode: "090200",
    id: "B02DB03KPH",
    position: ["112.989376", "28.173845"],
  },
  {
    name: "The First Affiliated Hospital of Sun Yat-sen University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "440000",
    pname: "Guangdong Province",
    adcode: "440104",
    adname: "Yuexiu District",
    citycode: "020",
    cityname: "Guangzhou City",
    typecode: "090101",
    id: "B00140226E",
    position: ["113.291159", "23.126327"],
  },
  {
    name: "The Third Affiliated Hospital of Sun Yat-sen University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "440000",
    pname: "Guangdong Province",
    adcode: "440106",
    adname: "Tianhe District",
    citycode: "020",
    cityname: "Guangzhou City",
    typecode: "090101",
    id: "B0FFF5UY3V",
    position: ["113.341211", "23.134165"],
  },
  {
    name: "Sun Yat-Sen Memorial Hospital of Sun Yat-Sen University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "440000",
    pname: "Guangdong Province",
    adcode: "440104",
    adname: "Yuexiu District",
    citycode: "020",
    cityname: "Guangzhou City",
    typecode: "090101",
    id: "B0FFH3TURK",
    position: ["113.255889", "23.109552"],
  },
  {
    name: "The Fifth Affiliated Hospital of Sun Yat-sen University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "440000",
    pname: "Guangdong Province",
    adcode: "440402",
    adname: "Xiangzhou District",
    citycode: "0756",
    cityname: "Zhuhai",
    typecode: "090101",
    id: "B02F400ISX",
    position: ["113.573455", "22.298425"],
  },
  {
    name: "Guangdong Provincial People's Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "440000",
    pname: "Guangdong Province",
    adcode: "440104",
    adname: "Yuexiu District",
    citycode: "020",
    cityname: "Guangzhou City",
    typecode: "090101",
    id: "B00140UERJ",
    position: ["113.287272", "23.125087"],
  },
  {
    name: "Guangdong No. 2 People's Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "440000",
    pname: "Guangdong Province",
    adcode: "440105",
    adname: "Haizhu District",
    citycode: "020",
    cityname: "Guangzhou City",
    typecode: "100104",
    id: "B0014043F6",
    Position: ["113.335513", "23.095585"],
  },
  {
    name: "Nanfang Hospital of Southern Medical University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "440000",
    pname: "Guangdong Province",
    adcode: "440111",
    adname: "Baiyun District",
    citycode: "020",
    cityname: "Guangzhou City",
    typecode: "100103",
    id: "B00140CK8U",
    position: ["113.329537", "23.187643"],
  },
  {
    name: "Zhujiang Hospital of Southern Medical University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "440000",
    pname: "Guangdong Province",
    adcode: "440105",
    adname: "Haizhu District",
    citycode: "020",
    cityname: "Guangzhou City",
    typecode: "090101",
    id: "B00140C1IU",
    Position: ["113.268936", "23.081055"],
  },
  {
    name: "The First Affiliated Hospital of Guangzhou Medical University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "440000",
    pname: "Guangdong Province",
    adcode: "440104",
    adname: "Yuexiu District",
    citycode: "020",
    cityname: "Guangzhou City",
    typecode: "141300",
    id: "B00140BBHL",
    position: ["113.262511", "23.112177"],
  },
  {
    name: "The Second Affiliated Hospital of Guangzhou Medical University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "440000",
    pname: "Guangdong Province",
    adcode: "440105",
    adname: "Haizhu District",
    citycode: "020",
    cityname: "Guangzhou City",
    typecode: "090101",
    id: "B00140UGDV",
    position: ["113.278609", "23.089880"],
  },
  {
    name: "The Third Affiliated Hospital of Guangzhou Medical University",
    type: "Level 3A",
    level: "General hospitals",
    parent: "",
    pcode: "440000",
    pname: "Guangdong Province",
    adcode: "440103",
    adname: "Lai Wan District",
    citycode: "020",
    cityname: "Guangzhou City",
    typecode: "090101",
    id: "B00140I6VS",
    Position: ["113.234177", "23.117800"],
  },
  {
    name: "Guangdong Provincial Hospital of Traditional Chinese Medicine",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "440000",
    pname: "Guangdong Province",
    adcode: "440104",
    adname: "Yuexiu District",
    citycode: "020",
    cityname: "Guangzhou City",
    typecode: "090101",
    id: "B00140U136",
    Position: ["113.256550", "23.118113"],
  },
  {
    name: "The First Affiliated Hospital of Jinan University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "440000",
    pname: "Guangdong Province",
    adcode: "440106",
    adname: "Tianhe District",
    citycode: "020",
    cityname: "Guangzhou City",
    typecode: "070000",
    id: "B0J2TD3X8B",
    Position: ["113.350217", "23.127149"],
  },
  {
    name: "Guangzhou Women's and Children's Medical Centre",
    type: "Level 3A",
    level: "Specialist hospitals (women and children)",
    parent: "",
    pcode: "440000",
    pname: "Guangdong Province",
    adcode: "440104",
    adname: "Yuexiu District",
    citycode: "020",
    cityname: "Guangzhou City",
    typecode: "090200",
    id: "B00140H3IU",
    position: ["113.253796", "23.119396"],
  },
  {
    name: "Fu Wai Hospital of Chinese Academy of Medical Sciences Shenzhen Hospital",
    type: "Level 3A",
    level: "Specialist hospitals (cardiovascular)",
    parent: "",
    pcode: "440000",
    pname: "Guangdong Province",
    adcode: "440305",
    adname: "Nanshan District",
    citycode: "0755",
    cityname: "Shenzhen",
    typecode: "090200",
    id: "B02F38MTDW",
    position: ["113.947663", "22.556961"],
  },
  {
    name: "Shenzhen People's Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "440000",
    pname: "Guangdong Province",
    adcode: "440303",
    adname: "Luohu District",
    citycode: "0755",
    cityname: "Shenzhen",
    typecode: "090101",
    id: "B02F37W9ER",
    position: ["114.128030", "22.557525"],
  },
  {
    name: "Shenzhen Third People's Hospital",
    type: "Level 3A",
    level: "General hospitals (specialities such as infectious diseases)",
    parent: "",
    pcode: "440000",
    pname: "Guangdong Province",
    adcode: "440307",
    adname: "Longgang District",
    citycode: "0755",
    cityname: "Shenzhen",
    typecode: "090101",
    id: "B02F38JF90",
    position: ["114.128750", "22.635393"],
  },
  {
    name: "Zhongshan Municipal People's Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "440000",
    pname: "Guangdong Province",
    adcode: "442000",
    adname: "Zhongshan City",
    citycode: "0760",
    cityname: "Zhongshan City",
    typecode: "090101",
    id: "B02F8008N5",
    position: ["113.383715", "22.525426"],
  },
  {
    name: "Foshan First People's Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "440000",
    pname: "Guangdong Province",
    adcode: "440604",
    adname: "chancheng district",
    citycode: "0757",
    cityname: "Foshan",
    typecode: "090101",
    id: "B02F501YDX",
    position: ["113.124749", "23.006370"],
  },
  {
    name: "General Hospital of the Southern Theatre of the Chinese People's Liberation Army",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "440000",
    pname: "Guangdong Province",
    adcode: "440104",
    adname: "Yuexiu District",
    citycode: "020",
    cityname: "Guangzhou City",
    typecode: "090101",
    id: "B00141RGH5",
    position: ["113.254855", "23.142608"],
  },
  {
    name: "Chinese People's Liberation Army Southern Theatre Air Force Hospital",
    type: "Level 3A",
    level: "General Hospital (Air Force Speciality Related Medicine)",
    parent: "",
    pcode: "440000",
    pname: "Guangdong Province",
    adcode: "440104",
    adname: "Yuexiu District",
    citycode: "020",
    cityname: "Guangzhou City",
    typecode: "120302",
    id: "B0FFF3V087",
    position: ["113.314114", "23.132953"],
  },
  {
    name: "Guangxi Zhuang Autonomous Region People's Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "450000",
    pname: "Guangxi Zhuang Autonomous Region",
    adcode: "450103",
    adname: "Qingxiu District",
    citycode: "0771",
    cityname: "Nanning",
    typecode: "090101",
    id: "B030300767",
    position: ["108.327964", "22.802248"],
  },
  {
    name: "The First Affiliated Hospital of Guangxi Medical University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "450000",
    pname: "Guangxi Zhuang Autonomous Region",
    adcode: "450103",
    adname: "Qingxiu District",
    citycode: "0771",
    cityname: "Nanning",
    typecode: "090101",
    id: "B03030044A",
    position: ["108.343151", "22.795874"],
  },
  {
    name: "The Second Affiliated Hospital of Guangxi Medical University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "450000",
    pname: "Guangxi Zhuang Autonomous Region",
    adcode: "450107",
    adname: "Xixiangtang District",
    citycode: "0771",
    cityname: "Nanning",
    typecode: "090101",
    id: "B0FFHLD7SC",
    position: ["108.259811", "22.841281"],
  },
  {
    name: "Ruikang Hospital, Guangxi University of Traditional Chinese Medicine",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "450000",
    pname: "Guangxi Zhuang Autonomous Region",
    adcode: "450102",
    adname: "Xingning District",
    citycode: "0771",
    cityname: "Nanning",
    typecode: "090101",
    id: "B0303056U6",
    position: ["108.314762", "22.821812"],
  },
  {
    name: "Chinese People's Liberation Army Joint Command and Guarantee Force Ninety-fourth Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "450000",
    pname: "Guangxi Zhuang Autonomous Region",
    adcode: "450304",
    adname: "Elephant Hill District",
    citycode: "0773",
    cityname: "Guilin",
    typecode: "090101",
    id: "B0FFJX8ZRE",
    position: ["110.293958", "25.265328"],
  },
  {
    name: "Chinese People's Liberation Army Joint Logistics Force 923rd Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "450000",
    pname: "Guangxi Zhuang Autonomous Region",
    adcode: "450203",
    adname: "Fishbone District",
    citycode: "0772",
    cityname: "Liuzhou",
    typecode: "130104",
    id: "B03040OIG0",
    position: ["109.429093", "24.282416"],
  },
  {
    name: "The Second Affiliated Hospital of Hainan Medical College",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "460000",
    pname: "Hainan Province",
    adcode: "460106",
    adname: "Longhua District",
    citycode: "0898",
    cityname: "Haikou City",
    typecode: "090101",
    id: "B03820OY4N",
    Position: ["110.300158", "19.979264"],
  },
  {
    name: "Hainan Provincial People's Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "460000",
    pname: "Hainan Province",
    adcode: "460105",
    adname: "Xiuying District",
    citycode: "0898",
    cityname: "Haikou City",
    typecode: "090101",
    id: "B03820OIDK",
    position: ["110.287710", "20.004771"],
  },
  {
    name: "The First Affiliated Hospital of Chongqing Medical University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "500000",
    pname: "Chongqing Municipality",
    adcode: "500103",
    adname: "Yuzhong District",
    citycode: "023",
    cityname: "Chongqing Municipality",
    typecode: "090101",
    id: "B00170L57Q",
    position: ["106.512621", "29.530815"],
  },
  {
    name: "Children's Hospital of Chongqing Medical University",
    type: "Level 3A",
    level: "Specialist hospitals (paediatrics)",
    parent: "",
    pcode: "500000",
    pname: "Chongqing Municipality",
    adcode: "500103",
    adname: "Yuzhong District",
    citycode: "023",
    cityname: "Chongqing Municipality",
    typecode: "090101",
    id: "B00170L1A4",
    position: ["106.554387", "29.556188"],
  },
  {
    name: "The First Affiliated Hospital of the Army Military Medical University of the Chinese People's Liberation Army",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "500000",
    pname: "Chongqing Municipality",
    adcode: "500106",
    adname: "Shapingba District",
    citycode: "023",
    cityname: "Chongqing Municipality",
    typecode: "090101",
    id: "B00170914B",
    position: ["106.452226", "29.536801"],
  },
  {
    name: "The Second Affiliated Hospital of the Army Military Medical University of the Chinese People's Liberation Army",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "500000",
    pname: "Chongqing Municipality",
    adcode: "500103",
    adname: "Yuzhong District",
    citycode: "023",
    cityname: "Chongqing Municipality",
    typecode: "050100",
    id: "B0FFFAJWEQ",
    position: ["106.525912", "29.542336"],
  },
  {
    name: "Chinese People's Liberation Army Army Specialty Medical Centre",
    type: "Level 3A",
    level: "General Hospital",
    parent: "B00178XIWO",
    pcode: "500000",
    pname: "Chongqing Municipality",
    adcode: "500103",
    adname: "Yuzhong District",
    citycode: "023",
    cityname: "Chongqing Municipality",
    typecode: "070000",
    id: "B0FFGBW81E",
    position: ["106.505875", "29.537486"],
  },
  {
    name: "The Second Affiliated Hospital of Chongqing Medical University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "500000",
    pname: "Chongqing Municipality",
    adcode: "500103",
    adname: "Yuzhong District",
    citycode: "023",
    cityname: "Chongqing Municipality",
    typecode: "090101",
    id: "B001791T1I",
    position: ["106.574647", "29.560163"],
  },
  {
    name: "West China Hospital of Sichuan University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "510000",
    pname: "Sichuan Province",
    adcode: "510107",
    adname: "Wuhou District",
    citycode: "028",
    cityname: "Chengdu",
    typecode: "090101",
    id: "B001C05YG2",
    position: ["104.060469", "30.641522"],
  },
  {
    name: "Sichuan Provincial People's Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "B0IB2L08GG",
    pcode: "510000",
    pname: "Sichuan Province",
    adcode: "510105",
    adname: "Qingyang District",
    citycode: "028",
    cityname: "Chengdu",
    typecode: "090101",
    id: "B001C8VGCI",
    position: ["104.040057", "30.662931"],
  },
  {
    name: "General Hospital of the Western Theatre of the Chinese People's Liberation Army",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "510000",
    pname: "Sichuan Province",
    adcode: "510106",
    adname: "Jinniu District",
    citycode: "028",
    cityname: "Chengdu",
    typecode: "190301",
    id: "BZA9N503F4",
    position: ["104.114519", "30.746632"],
  },
  {
    name: "Chinese People's Liberation Army Western Theatre Air Force Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "510000",
    pname: "Sichuan Province",
    adcode: "510107",
    adname: "Wuhou District",
    citycode: "028",
    cityname: "Chengdu",
    typecode: "120302",
    id: "B001C09HNC",
    Position: ["104.058078", "30.615245"],
  },
  {
    name: "Affiliated Hospital of Guizhou Medical University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "520000",
    pname: "Guizhou Province",
    adcode: "520103",
    adname: "Yunyan District",
    citycode: "0851",
    cityname: "Guiyang City",
    typecode: "141201",
    id: "B0FFG38B3H",
    position: ["106.715199", "26.598190"],
  },
  {
    name: "Guizhou Provincial People's Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "520000",
    pname: "Guizhou Province",
    adcode: "520102",
    adname: "Nanming District",
    citycode: "0851",
    cityname: "Guiyang City",
    typecode: "090101",
    id: "B035300VC0",
    position: ["106.722864", "26.576794"],
  },
  {
    name: "Affiliated Hospital of Zunyi Medical University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "520000",
    pname: "Guizhou Province",
    adcode: "520303",
    adname: "Huichuan District",
    citycode: "0852",
    cityname: "Zunyi",
    typecode: "090101",
    id: "B035400HOB",
    position: ["106.945268", "27.706648"],
  },
  {
    name: "The First Affiliated Hospital of Kunming Medical University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "530000",
    pname: "Yunnan Province",
    adcode: "530102",
    adname: "Wuhua District",
    citycode: "0871",
    cityname: "Kunming",
    typecode: "090101",
    id: "B036702A3E",
    position: ["102.693049", "25.042449"],
  },
  {
    name: "The Second Affiliated Hospital of Kunming Medical University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "530000",
    pname: "Yunnan Province",
    adcode: "530112",
    adname: "Nishiyama-ku",
    citycode: "0871",
    cityname: "Kunming",
    typecode: "141206",
    id: "B0FFHERQS6",
    position: ["102.680211", "25.026262"],
  },
  {
    name: "The First People's Hospital of Yunnan Province",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "530000",
    pname: "Yunnan Province",
    adcode: "530102",
    adname: "Wuhua District",
    citycode: "0871",
    cityname: "Kunming",
    typecode: "190301",
    id: "B0JU9ZD347",
    position: ["102.708531", "25.033377"],
  },
  {
    name: "Kunming First People's Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "530000",
    pname: "Yunnan Province",
    adcode: "530103",
    adname: "Panlong District",
    citycode: "0871",
    cityname: "Kunming",
    typecode: "090101",
    id: "B03670Z5UW",
    Position: ["102.736568", "25.091715"],
  },
  {
    name: "Yunnan Fuwai Cardiovascular Disease Hospital",
    type: "Level 3A",
    level: "Specialist hospitals (cardiovascular)",
    parent: "",
    pcode: "530000",
    pname: "Yunnan Province",
    adcode: "530102",
    adname: "Wuhua District",
    citycode: "0871",
    cityname: "Kunming",
    typecode: "160121",
    id: "B03670VXZL",
    position: ["102.667395", "25.243982"],
  },
  {
    name: "Kunming Yan'an Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "530000",
    pname: "Yunnan Province",
    adcode: "530103",
    adname: "Panlong District",
    citycode: "0871",
    cityname: "Kunming",
    typecode: "090101",
    id: "B036702A1F",
    position: ["102.730106", "25.042532"],
  },
  {
    name: "Tibet Autonomous Region People's Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "540000",
    pname: "Tibet Autonomous Region",
    adcode: "540102",
    adname: "Chengguan District",
    citycode: "0891",
    cityname: "Lhasa",
    typecode: "090101",
    id: "B0FFFX8HQY",
    position: ["91.127083", "29.656341"],
  },
  {
    name: "The First Affiliated Hospital of Xi'an Jiaotong University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "610000",
    pname: "Shaanxi Province",
    adcode: "610113",
    adname: "Yanta District",
    citycode: "029",
    cityname: "Xi'an",
    typecode: "090101",
    id: "B001D08AKU",
    Position: ["108.936741", "34.219569"],
  },
  {
    name: "Shaanxi Provincial People's Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "610000",
    pname: "Shaanxi Province",
    adcode: "610103",
    adname: "Beilin District",
    citycode: "029",
    cityname: "Xi'an",
    typecode: "190301",
    id: "B0FFH6ITJW",
    position: ["108.928750", "34.241136"],
  },
  {
    name: "The First Affiliated Hospital of the Air Force Military Medical University of the People's Liberation Army",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "610000",
    pname: "Shaanxi Province",
    adcode: "610102",
    adname: "New Town",
    citycode: "029",
    cityname: "Xi'an",
    typecode: "110105",
    id: "B0FFFFSUU7",
    position: ["108.988205", "34.270005"],
  },
  {
    name: "The First Hospital of Lanzhou University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "620000",
    pname: "Gansu Province",
    adcode: "620102",
    adname: "Chengguan District",
    citycode: "0931",
    cityname: "Lanzhou",
    typecode: "090101",
    id: "B03A306A70",
    position: ["103.869288", "36.045769"],
  },
  {
    name: "The Second Hospital of Lanzhou University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "620000",
    pname: "Gansu Province",
    adcode: "620102",
    adname: "Chengguan District",
    citycode: "0931",
    cityname: "Lanzhou",
    typecode: "090101",
    id: "B03A3032B3",
    position: ["103.812965", "36.061106"],
  },
  {
    name: "Gansu Provincial People's Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "620000",
    pname: "Gansu Province",
    adcode: "620102",
    adname: "Chengguan District",
    citycode: "0931",
    cityname: "Lanzhou",
    typecode: "090101",
    id: "B03A30AKI4",
    Position: ["103.867220", "36.048550"],
  },
  {
    name: "Chinese People's Liberation Army Joint Command and Guarantee Force Ninety-fourth Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "620000",
    pname: "Gansu Province",
    adcode: "620103",
    adname: "Chilihe District",
    citycode: "0931",
    cityname: "Lanzhou",
    typecode: "190301",
    id: "B0FFGRNU3F",
    position: ["103.785285", "36.066813"],
  },
  {
    name: "Qinghai Provincial People's Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "630000",
    pname: "Qinghai Province",
    adcode: "630102",
    adname: "City East",
    citycode: "0971",
    cityname: "Xining City",
    typecode: "090101",
    id: "B03CB06K0N",
    position: ["101.803480", "36.619875"],
  },
  {
    name: "Qinghai University Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "630000",
    pname: "Qinghai Province",
    adcode: "630104",
    adname: "City West",
    citycode: "0971",
    cityname: "Xining City",
    typecode: "090101",
    id: "B0FFFQ1X4R",
    Position: ["101.763392", "36.623021"],
  },
  {
    name: "Qinghai Provincial Specialist Hospital for Cardiovascular and Cerebrovascular Diseases",
    type: "Level 3A",
    level: "Specialist hospitals (cardiovascular and cerebrovascular diseases)",
    parent: "",
    pcode: "630000",
    pname: "Qinghai Province",
    adcode: "630104",
    adname: "City West",
    citycode: "0971",
    cityname: "Xining City",
    typecode: "190301",
    id: "B0IA34HNEK",
    position: ["101.662732", "36.649849"],
  },
  {
    name: "General Hospital of Ningxia Medical University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "640000",
    pname: "Ningxia Hui Autonomous Region",
    adcode: "640104",
    adname: "Xingqing District",
    citycode: "0951",
    cityname: "Yinchuan",
    typecode: "190700",
    id: "B0HGTZ78S3",
    position: ["106.278714", "38.432015"],
  },
  {
    name: "Ningxia Hui Autonomous Region People's Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "B03B703QBU",
    pcode: "640000",
    pname: "Ningxia Hui Autonomous Region",
    adcode: "640106",
    adname: "Jinfeng District",
    citycode: "0951",
    cityname: "Yinchuan",
    typecode: "090101",
    id: "B0FFG4RB4Q",
    position: ["106.253409", "38.503823"],
  },
  {
    name: "The First Affiliated Hospital of Xinjiang Medical University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "650000",
    pname: "Xinjiang Uygur Autonomous Region",
    adcode: "650104",
    adname: "New Downtown",
    citycode: "0991",
    cityname: "Urumqi",
    typecode: "141201",
    id: "B03DF066N4",
    position: ["87.579571", "43.836944"],
  },
  {
    name: "Xinjiang Uygur Autonomous Region People's Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "650000",
    pname: "Xinjiang Uygur Autonomous Region",
    adcode: "650102",
    adname: "Tien Shan District",
    citycode: "0991",
    cityname: "Urumqi",
    typecode: "090101",
    id: "B03DF04GDA",
    position: ["87.613961", "43.783896"],
  },
  {
    name: "Xinjiang Military Region General Hospital of the Chinese People's Liberation Army",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "650000",
    pname: "Xinjiang Uygur Autonomous Region",
    adcode: "650103",
    adname: "Shaybak District",
    citycode: "0991",
    cityname: "Urumqi",
    typecode: "120302",
    id: "B03DF06OF2",
    position: ["87.584244", "43.828361"],
  },
];

export const kidneyData = [
  {
    name: "Peking Union Medical College Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "110000",
    pname: "Beijing Municipality",
    adcode: "110101",
    adname: "Dongcheng District",
    citycode: "010",
    cityname: "Beijing Municipality",
    typecode: "090101",
    id: "B000A82Z2N",
    position: ["116.415768", "39.912682"],
  },
  {
    name: "Beijing Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "110000",
    pname: "Beijing Municipality",
    adcode: "110101",
    adname: "Dongcheng District",
    citycode: "010",
    cityname: "Beijing Municipality",
    typecode: "090101",
    id: "B000A52E0B",
    position: ["116.415057", "39.903772"],
  },
  {
    name: "China-Japan Friendship Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "110000",
    pname: "Beijing Municipality",
    adcode: "110105",
    adname: "Chaoyang District",
    citycode: "010",
    cityname: "Beijing Municipality",
    typecode: "090101",
    id: "B000A8370S",
    position: ["116.426883", "39.974097"],
  },
  {
    name: "Peking University First Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "110000",
    pname: "Beijing Municipality",
    adcode: "110102",
    adname: "Xicheng District",
    citycode: "010",
    cityname: "Beijing Municipality",
    typecode: "090101",
    id: "B000A7CNNE",
    position: ["116.380745", "39.931911"],
  },
  {
    name: "Peking University People's Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "110000",
    pname: "Beijing Municipality",
    adcode: "110102",
    adname: "Xicheng District",
    citycode: "010",
    cityname: "Beijing Municipality",
    typecode: "090101",
    id: "B000A5BA25",
    position: ["116.354215", "39.936961"],
  },
  {
    name: "Third Hospital of Peking University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "110000",
    pname: "Beijing Municipality",
    adcode: "110108",
    adname: "Haidian District",
    citycode: "010",
    cityname: "Beijing Municipality",
    typecode: "090101",
    id: "B000A7CGSS",
    Position: ["116.360010", "39.982728"],
  },
  {
    name: "Peking University International Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "B000A887DZ",
    pcode: "110000",
    pname: "Beijing Municipality",
    adcode: "110114",
    adname: "Changping District",
    citycode: "010",
    cityname: "Beijing Municipality",
    typecode: "090100",
    id: "B000A9Q0A3",
    Position: ["116.263513", "40.101167"],
  },
  {
    name: "Xuanwu Hospital of Capital Medical University",
    type: "Level 3A",
    level: "General hospitals (with emphasis on neuroscience, etc.)",
    parent: "B000A844ET",
    pcode: "110000",
    pname: "Beijing Municipality",
    adcode: "110102",
    adname: "Xicheng District",
    citycode: "010",
    cityname: "Beijing Municipality",
    typecode: "090101",
    id: "B000A3EA6A",
    position: ["116.362275", "39.891298"],
  },
  {
    name: "Beijing Chaoyang Hospital of Capital Medical University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "110000",
    pname: "Beijing Municipality",
    adcode: "110105",
    adname: "Chaoyang District",
    citycode: "010",
    cityname: "Beijing Municipality",
    typecode: "090101",
    id: "B000A845NT",
    position: ["116.453397", "39.925878"],
  },
  {
    name: "Beijing Friendship Hospital of Capital Medical University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "110000",
    pname: "Beijing Municipality",
    adcode: "110102",
    adname: "Xicheng District",
    citycode: "010",
    cityname: "Beijing Municipality",
    typecode: "090101",
    id: "B000A11DA0",
    position: ["116.392125", "39.885153"],
  },
  {
    name: "Beijing Tsinghua Changgeng Hospital, Tsinghua University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "110000",
    pname: "Beijing Municipality",
    adcode: "110114",
    adname: "Changping District",
    citycode: "010",
    cityname: "Beijing Municipality",
    typecode: "090100",
    id: "B0FFF4BCKE",
    position: ["116.414943", "40.072551"],
  },
  {
    name: "General Hospital of the Chinese People's Liberation Army",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "110000",
    pname: "Beijing Municipality",
    adcode: "110108",
    adname: "Haidian District",
    citycode: "010",
    cityname: "Beijing Municipality",
    typecode: "090101",
    id: "B000A9DPJ4",
    Position: ["116.276578", "39.904572"],
  },
  {
    name: "Chinese People's Liberation Army Air Force Centre for Specialty Medicine",
    type: "Level 3A",
    level: "General Hospital (Air Force Speciality Related Medicine)",
    parent: "B000A8VUX1",
    pcode: "110000",
    pname: "Beijing Municipality",
    adcode: "110108",
    adname: "Haidian District",
    citycode: "010",
    cityname: "Beijing Municipality",
    typecode: "090101",
    id: "B0FFLHMWBQ",
    position: ["116.302098", "39.920315"],
  },
  {
    name: "Tianjin First Central Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "120000",
    pname: "Tianjin",
    adcode: "120104",
    adname: "Nankai District",
    citycode: "022",
    cityname: "Tianjin",
    typecode: "090101",
    id: "B0016063Z3",
    position: ["117.151896", "39.101076"],
  },
  {
    name: "The Second Hospital of Hebei Medical University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "130000",
    pname: "Hebei Province",
    adcode: "130105",
    adname: "Xinhua District",
    citycode: "0311",
    cityname: "Shijiazhuang",
    typecode: "090101",
    id: "B0137063F3",
    Position: ["114.482117", "38.058064"],
  },
  {
    name: "Beidaihe Rehabilitation and Nursing Centre of the Joint Logistics Support Force of the Chinese People's Liberation Army",
    type: "Level 3A",
    level:
      "sanatoriums and rehabilitation institutions (with some medical capacity)",
    parent: "",
    pcode: "130000",
    pname: "Hebei Province",
    adcode: "130304",
    adname: "Beidaihe District",
    citycode: "0335",
    cityname: "Qinhuangdao City",
    typecode: "080402",
    id: "B0FFHWMUUK",
    position: ["119.436487", "39.807535"],
  },
  {
    name: "Shanxi Provincial People's Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "140000",
    pname: "Shanxi Province",
    adcode: "140106",
    adname: "Yingze District",
    citycode: "0351",
    cityname: "Taiyuan",
    typecode: "190301",
    id: "BZCNP101UF",
    position: ["112.580674", "37.845995"],
  },
  {
    name: "Shanxi Second People's Hospital",
    type: "Level 3A",
    level:
      "General hospitals (may focus on some specialities such as nephrology)",
    parent: "",
    pcode: "140000",
    pname: "Shanxi Province",
    adcode: "140106",
    adname: "Yingze District",
    citycode: "0351",
    cityname: "Taiyuan",
    typecode: "090200",
    id: "B015F008D1",
    position: ["112.556525", "37.843484"],
  },
  {
    name: "Datong Third People's Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "140000",
    pname: "Shanxi Province",
    adcode: "140213",
    adname: "Pingcheng District",
    citycode: "0352",
    cityname: "Datong",
    typecode: "090101",
    id: "B016000B0U",
    Position: ["113.287731", "40.075053"],
  },
  {
    name: "Shanxi Baiqiu'en Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "140000",
    pname: "Shanxi Province",
    adcode: "140105",
    adname: "Xiaodian District",
    citycode: "0351",
    cityname: "Taiyuan",
    typecode: "090101",
    id: "B0FFKYMJBB",
    position: ["112.555225", "37.777302"],
  },
  {
    name: "Inner Mongolia Baogang Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "150000",
    pname: "Inner Mongolia Autonomous Region",
    adcode: "150203",
    adname: "Kundulun District",
    citycode: "0472",
    cityname: "Baotou",
    typecode: "090101",
    id: "B01D80108C",
    position: ["109.824671", "40.652117"],
  },
  {
    name: "The First Hospital of China Medical University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "210000",
    pname: "Liaoning Province",
    adcode: "210102",
    adname: "Peace District",
    citycode: "024",
    cityname: "Shenyang City",
    typecode: "090101",
    id: "B00180CWQO",
    position: ["123.411350", "41.795344"],
  },
  {
    name: "The Second Hospital of Dalian Medical University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "210000",
    pname: "Liaoning Province",
    adcode: "210204",
    adname: "Shahekou District",
    citycode: "0411",
    cityname: "Dalian",
    typecode: "090101",
    id: "B019B0AOZE",
    position: ["121.570231", "38.882761"],
  },
  {
    name: "Dalian Friendship Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "210000",
    pname: "Liaoning Province",
    adcode: "210202",
    adname: "Central Hill District",
    citycode: "0411",
    cityname: "Dalian",
    typecode: "090101",
    id: "B019B111J1",
    Position: ["121.657033", "38.921100"],
  },
  {
    name: "鞍钢集团总医院",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "210000",
    pname: "Liaoning Province",
    adcode: "210302",
    adname: "Tiedong District",
    citycode: "0412",
    cityname: "Anshan",
    typecode: "090101",
    id: "B0FFF5TZTT",
    Position: ["123.011252", "41.120319"],
  },
  {
    name: "General Hospital of the Northern War Area of the Chinese People's Liberation Army",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "210000",
    pname: "Liaoning Province",
    adcode: "210103",
    adname: "Shenhe District",
    citycode: "024",
    cityname: "Shenyang City",
    typecode: "090101",
    id: "B0FFJU0NYC",
    Position: ["123.440500", "41.769683"],
  },
  {
    name: "Chinese People's Liberation Army Air Force Hospital of the Northern Theatre",
    type: "Level 3A",
    level: "General Hospital (Air Force Speciality Related Medicine)",
    parent: "",
    pcode: "210000",
    pname: "Liaoning Province",
    adcode: "210104",
    adname: "Greater East Side",
    citycode: "024",
    cityname: "Shenyang City",
    typecode: "090207",
    id: "B001802FB0",
    position: ["123.472908", "41.793921"],
  },
  {
    name: "Baiqiu'en First Hospital of Jilin University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "B01AF06SEY",
    pcode: "220000",
    pname: "Jilin Province",
    adcode: "220104",
    adname: "Chaoyang District",
    citycode: "0431",
    cityname: "Changchun",
    typecode: "090101",
    id: "B01AF127AE",
    Position: ["125.304855", "43.877282"],
  },
  {
    name: "The First Hospital of Harbin Medical University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "B01C30JIUR",
    pcode: "230000",
    pname: "Heilongjiang Province",
    adcode: "230103",
    adname: "Nangang District",
    citycode: "0451",
    cityname: "Harbin",
    typecode: "150904",
    id: "B01C30JIWH",
    position: ["126.650518", "45.764741"],
  },
  {
    name: "The Second Hospital of Harbin Medical University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "B01C30JJ8F",
    pcode: "230000",
    pname: "Heilongjiang Province",
    adcode: "230103",
    adname: "Nangang District",
    citycode: "0451",
    cityname: "Harbin",
    typecode: "050100",
    id: "B0FFIQS9N6",
    position: ["126.619554", "45.694548"],
  },
  {
    name: "Zhongshan Hospital of Fudan University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "310000",
    pname: "Shanghai",
    adcode: "310104",
    adname: "Xuhui District",
    citycode: "021",
    cityname: "Shanghai Municipality",
    typecode: "090101",
    id: "B00156TKFX",
    position: ["121.454965", "31.197318"],
  },
  {
    name: "Huashan Hospital of Fudan University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "310000",
    pname: "Shanghai",
    adcode: "310106",
    adname: "Jing'an District",
    citycode: "021",
    cityname: "Shanghai Municipality",
    typecode: "090101",
    id: "B00155KT4W",
    position: ["121.442932", "31.216111"],
  },
  {
    name: "Paediatric Hospital Affiliated to Fudan University",
    type: "Level 3A",
    level: "Specialist hospitals (paediatrics)",
    parent: "",
    pcode: "310000",
    pname: "Shanghai",
    adcode: "310112",
    adname: "Minhang District",
    citycode: "021",
    cityname: "Shanghai Municipality",
    typecode: "090200",
    id: "B00155KP0U",
    position: ["121.394971", "31.139147"],
  },
  {
    name: "Shanghai First People's Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "310000",
    pname: "Shanghai",
    adcode: "310109",
    adname: "Hongkou District",
    citycode: "021",
    cityname: "Shanghai Municipality",
    typecode: "141300",
    id: "B00153A582",
    position: ["121.489273", "31.253352"],
  },
  {
    name: "Ruijin Hospital of Shanghai Jiaotong University School of Medicine",
    type: "Level 3A",
    level: "General Hospital",
    parent: "B00156QHJ2",
    pcode: "310000",
    pname: "Shanghai",
    adcode: "310101",
    adname: "Huangpu District",
    citycode: "021",
    cityname: "Shanghai Municipality",
    typecode: "090101",
    id: "B00155L9T9",
    position: ["121.467617", "31.211761"],
  },
  {
    name: "Renji Hospital, Shanghai Jiaotong University School of Medicine",
    type: "Level 3A",
    level: "General Hospital",
    parent: "B00155L1WO",
    pcode: "310000",
    pname: "Shanghai",
    adcode: "310101",
    adname: "Huangpu District",
    citycode: "021",
    cityname: "Shanghai Municipality",
    typecode: "090101",
    id: "B001570WJ3",
    position: ["121.484270", "31.233971"],
  },
  {
    name: "The First Affiliated Hospital of the Navy Military Medical University of the Chinese People's Liberation Army",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "310000",
    pname: "Shanghai",
    adcode: "310110",
    adname: "Yangpu District",
    citycode: "021",
    cityname: "Shanghai Municipality",
    typecode: "140000",
    id: "B0FFJ597NX",
    position: ["121.529259", "31.306753"],
  },
  {
    name: "The Second Affiliated Hospital of the Navy Military Medical University of the Chinese People's Liberation Army",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "310000",
    pname: "Shanghai",
    adcode: "310115",
    adname: "Pudong New Area",
    citycode: "021",
    cityname: "Shanghai Municipality",
    typecode: "090101",
    id: "B00156YLJ4",
    position: ["121.512572", "31.148012"],
  },
  {
    name: "The First Affiliated Hospital of Soochow University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "B0FFL1OLPA",
    pcode: "320000",
    pname: "Jiangsu Province",
    adcode: "320508",
    adname: "Gusu District",
    citycode: "0512",
    cityname: "Suzhou",
    typecode: "050100",
    id: "B0FFFCVC0F",
    position: ["120.634399", "31.304555"],
  },
  {
    name: "Wuxi People's Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "320000",
    pname: "Jiangsu Province",
    adcode: "320213",
    adname: "Liangxi District",
    citycode: "0510",
    cityname: "Wuxi City",
    typecode: "090101",
    id: "B01FE0II5H",
    position: ["120.323368", "31.540592"],
  },
  {
    name: "Changzhou First People's Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "320000",
    pname: "Jiangsu Province",
    adcode: "320402",
    adname: "Tianning District",
    citycode: "0519",
    cityname: "Changzhou City",
    typecode: "090101",
    id: "B020701JQM",
    position: ["119.960866", "31.779492"],
  },
  {
    name: "General Hospital of the Eastern Theatre of the Chinese People's Liberation Army",
    type: "Level 3A",
    level: "General Hospital",
    parent: "B0FFJRI5KZ",
    pcode: "320000",
    pname: "Jiangsu Province",
    adcode: "320102",
    adname: "Xuanwu District",
    citycode: "025",
    cityname: "Nanjing",
    typecode: "090101",
    id: "B0FFJRY861",
    position: ["118.808021", "32.040747"],
  },
  {
    name: "The Second Affiliated Hospital of Nanjing Medical University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "320000",
    pname: "Jiangsu Province",
    adcode: "320106",
    adname: "Gulou District",
    citycode: "025",
    cityname: "Nanjing",
    typecode: "090101",
    id: "B00190A90H",
    position: ["118.744998", "32.080323"],
  },
  {
    name: "Affiliated Hospital of Xuzhou Medical University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "320000",
    pname: "Jiangsu Province",
    adcode: "320311",
    adname: "Quanshan District",
    citycode: "0516",
    cityname: "Xuzhou",
    typecode: "160104",
    id: "B0FFGX2SW1",
    position: ["117.179368", "34.263154"],
  },
  {
    name: "The First Hospital Affiliated to the Medical College of Zhejiang University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "330000",
    pname: "Zhejiang Province",
    adcode: "330102",
    adname: "Uptown",
    citycode: "0571",
    cityname: "Hangzhou",
    typecode: "090101",
    id: "B023B0929X",
    position: ["120.177825", "30.255920"],
  },
  {
    name: "The Second Affiliated Hospital of Zhejiang University School of Medicine",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "330000",
    pname: "Zhejiang Province",
    adcode: "330102",
    adname: "Uptown",
    citycode: "0571",
    cityname: "Hangzhou",
    typecode: "090101",
    id: "B0FFG8HLTS",
    position: ["120.177439", "30.251172"],
  },
  {
    name: "Run Run Shaw Hospital, Zhejiang University School of Medicine",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "330000",
    pname: "Zhejiang Province",
    adcode: "330102",
    adname: "Uptown",
    citycode: "0571",
    cityname: "Hangzhou",
    typecode: "090101",
    id: "B023B051V6",
    Position: ["120.202351", "30.256376"],
  },
  {
    name: "Children's Hospital of Zhejiang University School of Medicine",
    type: "Level 3A",
    level: "Specialist hospitals (paediatrics)",
    parent: "",
    pcode: "330000",
    pname: "Zhejiang Province",
    adcode: "330105",
    adname: "Gongshu District",
    citycode: "0571",
    cityname: "Hangzhou",
    typecode: "090200",
    id: "B023B06XYO",
    position: ["120.165734", "30.260224"],
  },
  {
    name: "The First Hospital of Wenzhou Medical University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "330000",
    pname: "Zhejiang Province",
    adcode: "330302",
    adname: "Deer District",
    citycode: "0577",
    cityname: "wenzhou",
    typecode: "090101",
    id: "B024103ZQM",
    Position: ["120.665318", "28.013566"],
  },
  {
    name: "Li Huili East Hospital, Ningbo Medical Centre",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "330000",
    pname: "Zhejiang Province",
    adcode: "330212",
    adname: "yinzhou district",
    citycode: "0574",
    cityname: "Ningbo",
    typecode: "100100",
    id: "B0FFI5SAZM",
    position: ["121.562708", "29.853098"],
  },
  {
    name: "Ningbo Yinzhou District Second Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "330000",
    pname: "Zhejiang Province",
    adcode: "330212",
    adname: "yinzhou district",
    citycode: "0574",
    cityname: "Ningbo",
    typecode: "190301",
    id: "B0FFH5APW9",
    position: ["121.552893", "29.808744"],
  },
  {
    name: "Shulan (Hangzhou) Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "330000",
    pname: "Zhejiang Province",
    adcode: "330105",
    adname: "Gongshu District",
    citycode: "0571",
    cityname: "Hangzhou",
    typecode: "090101",
    id: "B0FFG6IQYR",
    position: ["120.174522", "30.328786"],
  },
  {
    name: "Chinese People's Liberation Army Joint Logistics Force 103rd Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "330000",
    pname: "Zhejiang Province",
    adcode: "330106",
    adname: "Westlake",
    citycode: "0571",
    cityname: "Hangzhou",
    typecode: "120302",
    id: "B0J3MHF2OE",
    position: ["120.116301", "30.246458"],
  },
  {
    name: "The First Hospital Affiliated to the University of Science and Technology of China",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "340000",
    pname: "Anhui Province",
    adcode: "340104",
    adname: "Shushan District",
    citycode: "0551",
    cityname: "Hefei",
    typecode: "090101",
    id: "B022702OL9",
    position: ["117.267662", "31.847151"],
  },
  {
    name: "The First Affiliated Hospital of Anhui Medical University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "340000",
    pname: "Anhui Province",
    adcode: "340104",
    adname: "Shushan District",
    citycode: "0551",
    cityname: "Hefei",
    typecode: "090101",
    id: "B022702OL9",
    position: ["117.267662", "31.847151"],
  },
  {
    name: "The Second Affiliated Hospital of Anhui Medical University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "340000",
    pname: "Anhui Province",
    adcode: "340104",
    adname: "Shushan District",
    citycode: "0551",
    cityname: "Hefei",
    typecode: "090101",
    id: "B02270IHE7",
    position: ["117.212410", "31.790188"],
  },
  {
    name: "Union Hospital of Fujian Medical University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "350000",
    pname: "Fujian Province",
    adcode: "350102",
    adname: "Gulou District",
    citycode: "0591",
    cityname: "Fuzhou",
    typecode: "090101",
    id: "B024F01LIN",
    position: ["119.304020", "26.077841"],
  },
  {
    name: "Fujian Provincial Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "B024F04VN7",
    pcode: "350000",
    pname: "Fujian Province",
    adcode: "350102",
    adname: "Gulou District",
    citycode: "0591",
    cityname: "Fuzhou",
    typecode: "050100",
    id: "B0GRKU5LSZ",
    position: ["119.299381", "26.084133"],
  },
  {
    name: "Xiamen University Xiang'an Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "350000",
    pname: "Fujian Province",
    adcode: "350213",
    adname: "Xiang'an District",
    citycode: "0592",
    cityname: "Xiamen",
    typecode: "090100",
    id: "B02500QKUL",
    Position: ["118.350162", "24.585555"],
  },
  {
    name: "Chinese People's Liberation Army Joint Logistics Force Ninetieth Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "B0FFJRGU1I",
    pcode: "350000",
    pname: "Fujian Province",
    adcode: "350102",
    adname: "Gulou District",
    citycode: "0591",
    cityname: "Fuzhou",
    typecode: "090101",
    id: "B0FFK1YGP1",
    Position: ["119.280085", "26.092136"],
  },
  {
    name: "Jiangxi Provincial People's Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "360000",
    pname: "Jiangxi Province",
    adcode: "360102",
    adname: "Eastlake",
    citycode: "0791",
    cityname: "Nanchang",
    typecode: "120303",
    id: "B0FFF5OJLQ",
    position: ["115.887725", "28.691942"],
  },
  {
    name: "First Affiliated Hospital of Nanchang University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "360000",
    pname: "Jiangxi Province",
    adcode: "360102",
    adname: "Eastlake",
    citycode: "0791",
    cityname: "Nanchang",
    typecode: "090101",
    id: "B031702KIL",
    position: ["115.910291", "28.686539"],
  },
  {
    name: "The Second Affiliated Hospital of Nanchang University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "360000",
    pname: "Jiangxi Province",
    adcode: "360102",
    adname: "Eastlake",
    citycode: "0791",
    cityname: "Nanchang",
    typecode: "090101",
    id: "B031702VZZ",
    position: ["115.901957", "28.682490"],
  },
  {
    name: "Shandong University Qilu Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "370000",
    pname: "Shandong Province",
    adcode: "370102",
    adname: "Lixia District",
    citycode: "0531",
    cityname: "Jinan",
    typecode: "090101",
    id: "B02130WZ7F",
    Position: ["117.018773", "36.656637"],
  },
  {
    name: "The Second Hospital of Shandong University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "370000",
    pname: "Shandong Province",
    adcode: "370102",
    adname: "Lixia District",
    citycode: "0531",
    cityname: "Jinan",
    typecode: "090101",
    id: "B02130WZ7F",
    Position: ["117.018773", "36.656637"],
  },
  {
    name: "Shandong Provincial Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "370000",
    pname: "Shandong Province",
    adcode: "370104",
    adname: "locust district",
    citycode: "0531",
    cityname: "Jinan",
    typecode: "080603",
    id: "B0213014FF",
    Position: ["116.982434", "36.657591"],
  },
  {
    name: "Affiliated Hospital of Qingdao University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "370000",
    pname: "Shandong Province",
    adcode: "370202",
    adname: "市南区",
    citycode: "0532",
    cityname: "Qingdao",
    typecode: "090101",
    id: "B021403HO2",
    position: ["120.327228", "36.067916"],
  },
  {
    name: "Shandong Province Qianfoshan Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "370000",
    pname: "Shandong Province",
    adcode: "370102",
    adname: "Lixia District",
    citycode: "0531",
    cityname: "Jinan",
    typecode: "100105",
    id: "B0FFGQ30FC",
    Position: ["117.053823", "36.648165"],
  },
  {
    name: "Yantai Yuhuanding Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "370000",
    pname: "Shandong Province",
    adcode: "370602",
    adname: "chifu",
    citycode: "0535",
    cityname: "Yantai City",
    typecode: "090101",
    id: "B021704X7N",
    position: ["121.389746", "37.535769"],
  },
  {
    name: "Linyi City People's Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "370000",
    pname: "Shandong Province",
    adcode: "371302",
    adname: "Lanshan District",
    citycode: "0539",
    cityname: "Linyi",
    typecode: "090101",
    id: "B021B09FNI",
    Position: ["118.350793", "35.063762"],
  },
  {
    name: "Weifang City People's Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "370000",
    pname: "Shandong Province",
    adcode: "370705",
    adname: "Quiwen District",
    citycode: "0536",
    cityname: "Weifang",
    typecode: "141202",
    id: "B0218030BR",
    position: ["119.129473", "36.701748"],
  },
  {
    name: "Chinese People's Liberation Army Joint Logistics Force No. 960 Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "370000",
    pname: "Shandong Province",
    adcode: "370105",
    adname: "Tianqiao District",
    citycode: "0531",
    cityname: "Jinan",
    typecode: "090101",
    id: "B0FFJXWTMY",
    position: ["116.982558", "36.696924"],
  },
  {
    name: "Chinese People's Liberation Army Navy Hospital No. 971",
    type: "Level 3A",
    level: "General Hospital",
    parent: "B02140VT8F",
    pcode: "370000",
    pname: "Shandong Province",
    adcode: "370202",
    adname: "市南区",
    citycode: "0532",
    cityname: "Qingdao",
    typecode: "071600",
    id: "B0JG3DWGX3",
    Position: ["120.386284", "36.071360"],
  },
  {
    name: "The First Affiliated Hospital of Zhengzhou University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "410000",
    pname: "Henan Province",
    adcode: "410103",
    adname: "Erqi District",
    citycode: "0371",
    cityname: "Zhengzhou",
    typecode: "090101",
    id: "B0173080HG",
    position: ["113.646042", "34.752734"],
  },
  {
    name: "Henan Provincial People's Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "B01730KBLG",
    pcode: "410000",
    pname: "Henan Province",
    adcode: "410105",
    adname: "Jinshui District",
    citycode: "0371",
    cityname: "Zhengzhou",
    typecode: "061210",
    id: "B0JRFHS5VA",
    position: ["113.681492", "34.771209"],
  },
  {
    name: "Zhengzhou People's Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "B017305KKO",
    pcode: "410000",
    pname: "Henan Province",
    adcode: "410102",
    adname: "Central Plains District",
    citycode: "0371",
    cityname: "Zhengzhou",
    typecode: "090101",
    id: "B0IAJGR305",
    position: ["113.612287", "34.750256"],
  },
  {
    name: "Zhengzhou Seventh People's Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "410000",
    pname: "Henan Province",
    adcode: "410104",
    adname: "Guancheng Huizu District",
    citycode: "0371",
    cityname: "Zhengzhou",
    typecode: "090200",
    id: "B01730K9C6",
    position: ["113.740263", "34.713582"],
  },
  {
    name: "The First Affiliated Hospital of Henan College of Traditional Chinese Medicine",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "410000",
    pname: "Henan Province",
    adcode: "410105",
    adname: "Jinshui District",
    citycode: "0371",
    cityname: "Zhengzhou",
    typecode: "090101",
    id: "B0173046A3",
    position: ["113.674298", "34.759020"],
  },
  {
    name: "Chinese People's Liberation Army Joint Logistics Force 988 Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "410000",
    pname: "Henan Province",
    adcode: "410105",
    adname: "Jinshui District",
    citycode: "0371",
    cityname: "Zhengzhou",
    typecode: "190301",
    id: "B0IA3GLW9P",
    position: ["113.637196", "34.772961"],
  },
  {
    name: "Tongji Hospital, Tongji Medical College, Huazhong University of Science and Technology",
    type: "Level 3A",
    level: "General Hospital",
    parent: "B001B07JBE",
    pcode: "420000",
    pname: "Hubei Province",
    adcode: "420104",
    adname: "qiaokou district",
    citycode: "027",
    cityname: "Wuhan",
    typecode: "090101",
    id: "B0FFGTQYIR",
    position: ["114.262367", "30.579204"],
  },
  {
    name: "Union Hospital of Tongji Medical College, Huazhong University of Science and Technology",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "420000",
    pname: "Hubei Province",
    adcode: "420103",
    adname: "Jianghan District",
    citycode: "027",
    cityname: "Wuhan",
    typecode: "090101",
    id: "B001B0IZPF",
    position: ["114.274723", "30.584057"],
  },
  {
    name: "Wuhan University People's Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "B001B06652",
    pcode: "420000",
    pname: "Hubei Province",
    adcode: "420106",
    adname: "Wuchang District",
    citycode: "027",
    cityname: "Wuhan",
    typecode: "090101",
    id: "B001B1C7BQ",
    position: ["114.300585", "30.535761"],
  },
  {
    name: "Wuhan University Zhongnan Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "420000",
    pname: "Hubei Province",
    adcode: "420111",
    adname: "Hongshan District",
    citycode: "027",
    cityname: "Wuhan",
    typecode: "090100|090200",
    id: "B0FFKCKC2N",
    position: ["114.396585", "30.536372"],
  },
  {
    name: "Dongfeng General Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "420000",
    pname: "Hubei Province",
    adcode: "420303",
    adname: "Zhangwan District",
    citycode: "0719",
    cityname: "Shiyan",
    typecode: "060400|060100",
    id: "B02CF0QCF8",
    Position: ["110.771031", "32.653481"],
  },
  {
    name: "General Hospital of the Central Theatre of the Chinese People's Liberation Army",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "420000",
    pname: "Hubei Province",
    adcode: "420106",
    adname: "Wuchang District",
    citycode: "027",
    cityname: "Wuhan",
    typecode: "090101",
    id: "B0FFJS7ZOP",
    position: ["114.344866", "30.531123"],
  },
  {
    name: "Yichang Central People's Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "420000",
    pname: "Hubei Province",
    adcode: "420503",
    adname: "Wujiagang District",
    citycode: "0717",
    cityname: "Yichang",
    typecode: "090101",
    id: "B0FFFGWCLN",
    position: ["111.306907", "30.684410"],
  },
  {
    name: "Xiangya Hospital of Central South University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "430000",
    pname: "Hunan Province",
    adcode: "430105",
    adname: "Kaifu District",
    citycode: "0731",
    cityname: "Changsha City",
    typecode: "090101",
    id: "B02DB00B1E",
    position: ["112.984047", "28.212209"],
  },
  {
    name: "The Second Xiangya Hospital of Central South University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "430000",
    pname: "Hunan Province",
    adcode: "430102",
    adname: "Furong District",
    citycode: "0731",
    cityname: "Changsha City",
    typecode: "100103",
    id: "B02DB0VBWH",
    position: ["113.027619", "28.184897"],
  },
  {
    name: "Xiangya Third Hospital of Central South University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "430000",
    pname: "Hunan Province",
    adcode: "430104",
    adname: "Yuelu District",
    citycode: "0731",
    cityname: "Changsha City",
    typecode: "090101",
    id: "B02DB02J64",
    position: ["112.944798", "28.220483"],
  },
  {
    name: "Hunan Provincial People's Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "430000",
    pname: "Hunan Province",
    adcode: "430102",
    adname: "Furong District",
    citycode: "0731",
    cityname: "Changsha City",
    typecode: "090101",
    id: "B0H39RU13M",
    position: ["112.981993", "28.190395"],
  },
  {
    name: "Yiyang City Centre Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "430000",
    pname: "Hunan Province",
    adcode: "430903",
    adname: "Heshan District",
    citycode: "0737",
    cityname: "Yiyang City",
    typecode: "090100",
    id: "B02E1001PC",
    position: ["112.354620", "28.570175"],
  },
  {
    name: "Chenzhou First People's Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "430000",
    pname: "Hunan Province",
    adcode: "431002",
    adname: "North Lakes",
    citycode: "0735",
    cityname: "Chenzhou",
    typecode: "141201",
    id: "B02DF007E4",
    position: ["113.022814", "25.792694"],
  },
  {
    name: "The Second Affiliated Hospital of Nanhua University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "430000",
    pname: "Hunan Province",
    adcode: "430407",
    adname: "Stone Drum District",
    citycode: "0734",
    cityname: "Hengyang City",
    typecode: "190301",
    id: "B0IA3ZSFYS",
    position: ["112.606648", "26.896262"],
  },
  {
    name: "Changde First People's Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "430000",
    pname: "Hunan Province",
    adcode: "430702",
    adname: "Wuling District",
    citycode: "0736",
    cityname: "Changde City",
    typecode: "190301",
    id: "B0FFGD4CIX",
    position: ["111.693638", "29.028146"],
  },
  {
    name: "Yueyang No. 1 People's Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "B0HRSLRM6M",
    pcode: "430000",
    pname: "Hunan Province",
    adcode: "430602",
    adname: "Yueyanglou District",
    citycode: "0730",
    cityname: "Yueyang City",
    typecode: "090101",
    id: "B02DA014B2",
    position: ["113.111718", "29.372735"],
  },
  {
    name: "Hunan Children's Hospital",
    type: "Level 3A",
    level: "Specialist hospitals (paediatrics)",
    parent: "",
    pcode: "430000",
    pname: "Hunan Province",
    adcode: "430111",
    adname: "Yuhua District",
    citycode: "0731",
    cityname: "Changsha City",
    typecode: "090200",
    id: "B02DB03KPH",
    position: ["112.989376", "28.173845"],
  },
  {
    name: "The First Affiliated Hospital of Sun Yat-sen University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "440000",
    pname: "Guangdong Province",
    adcode: "440104",
    adname: "Yuexiu District",
    citycode: "020",
    cityname: "Guangzhou City",
    typecode: "090101",
    id: "B00140226E",
    position: ["113.291159", "23.126327"],
  },
  {
    name: "The Third Affiliated Hospital of Sun Yat-sen University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "440000",
    pname: "Guangdong Province",
    adcode: "440106",
    adname: "Tianhe District",
    citycode: "020",
    cityname: "Guangzhou City",
    typecode: "090101",
    id: "B0FFF5UY3V",
    position: ["113.341211", "23.134165"],
  },
  {
    name: "Sun Yat-Sen Memorial Hospital of Sun Yat-Sen University (Headquarter)",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "440000",
    pname: "Guangdong Province",
    adcode: "440104",
    adname: "Yuexiu District",
    citycode: "020",
    cityname: "Guangzhou City",
    typecode: "090101",
    id: "B0FFH3TURK",
    position: ["113.255889", "23.109552"],
  },
  {
    name: "The Fifth Affiliated Hospital of Sun Yat-sen University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "440000",
    pname: "Guangdong Province",
    adcode: "440402",
    adname: "Xiangzhou District",
    citycode: "0756",
    cityname: "Zhuhai",
    typecode: "090101",
    id: "B02F400ISX",
    position: ["113.573455", "22.298425"],
  },
  {
    name: "Guangdong Provincial People's Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "440000",
    pname: "Guangdong Province",
    adcode: "440104",
    adname: "Yuexiu District",
    citycode: "020",
    cityname: "Guangzhou City",
    typecode: "090101",
    id: "B00140UERJ",
    position: ["113.287272", "23.125087"],
  },
  {
    name: "Guangdong No. 2 People's Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "440000",
    pname: "Guangdong Province",
    adcode: "440105",
    adname: "Haizhu District",
    citycode: "020",
    cityname: "Guangzhou City",
    typecode: "100104",
    id: "B0014043F6",
    Position: ["113.335513", "23.095585"],
  },
  {
    name: "Nanfang Hospital of Southern Medical University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "440000",
    pname: "Guangdong Province",
    adcode: "440111",
    adname: "Baiyun District",
    citycode: "020",
    cityname: "Guangzhou City",
    typecode: "100103",
    id: "B00140CK8U",
    position: ["113.329537", "23.187643"],
  },
  {
    name: "Zhujiang Hospital of Southern Medical University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "440000",
    pname: "Guangdong Province",
    adcode: "440105",
    adname: "Haizhu District",
    citycode: "020",
    cityname: "Guangzhou City",
    typecode: "090101",
    id: "B00140C1IU",
    Position: ["113.268936", "23.081055"],
  },
  {
    name: "The First Affiliated Hospital of Guangzhou Medical University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "440000",
    pname: "Guangdong Province",
    adcode: "440104",
    adname: "Yuexiu District",
    citycode: "020",
    cityname: "Guangzhou City",
    typecode: "141300",
    id: "B00140BBHL",
    position: ["113.262511", "23.112177"],
  },
  {
    name: "The Second Affiliated Hospital of Guangzhou Medical University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "440000",
    pname: "Guangdong Province",
    adcode: "440105",
    adname: "Haizhu District",
    citycode: "020",
    cityname: "Guangzhou City",
    typecode: "090101",
    id: "B00140UGDV",
    position: ["113.278609", "23.089880"],
  },
  {
    name: "The Third Affiliated Hospital of Guangzhou Medical University",
    type: "Level 3A",
    level: "General hospitals",
    parent: "",
    pcode: "440000",
    pname: "Guangdong Province",
    adcode: "440103",
    adname: "Lai Wan District",
    citycode: "020",
    cityname: "Guangzhou City",
    typecode: "090101",
    id: "B00140I6VS",
    Position: ["113.234177", "23.117800"],
  },
  {
    name: "Guangdong Provincial Hospital of Traditional Chinese Medicine",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "440000",
    pname: "Guangdong Province",
    adcode: "440104",
    adname: "Yuexiu District",
    citycode: "020",
    cityname: "Guangzhou City",
    typecode: "090101",
    id: "B00140U136",
    Position: ["113.256550", "23.118113"],
  },
  {
    name: "The First Affiliated Hospital of Jinan University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "440000",
    pname: "Guangdong Province",
    adcode: "440106",
    adname: "Tianhe District",
    citycode: "020",
    cityname: "Guangzhou City",
    typecode: "070000",
    id: "B0J2TD3X8B",
    Position: ["113.350217", "23.127149"],
  },
  {
    name: "Shenzhen Third People's Hospital",
    type: "Level 3A",
    level: "General hospitals (specialities such as infectious diseases)",
    parent: "",
    pcode: "440000",
    pname: "Guangdong Province",
    adcode: "440307",
    adname: "Longgang District",
    citycode: "0755",
    cityname: "Shenzhen",
    typecode: "090101",
    id: "B02F38JF90",
    position: ["114.128750", "22.635393"],
  },
  {
    name: "Zhongshan Municipal People's Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "440000",
    pname: "Guangdong Province",
    adcode: "442000",
    adname: "Zhongshan City",
    citycode: "0760",
    cityname: "Zhongshan City",
    typecode: "090101",
    id: "B02F8008N5",
    position: ["113.383715", "22.525426"],
  },
  {
    name: "Foshan First People's Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "440000",
    pname: "Guangdong Province",
    adcode: "440604",
    adname: "chancheng district",
    citycode: "0757",
    cityname: "Foshan",
    typecode: "090101",
    id: "B02F501YDX",
    position: ["113.124749", "23.006370"],
  },
  {
    name: "General Hospital of the Southern Theatre of the Chinese People's Liberation Army",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "440000",
    pname: "Guangdong Province",
    adcode: "440104",
    adname: "Yuexiu District",
    citycode: "020",
    cityname: "Guangzhou City",
    typecode: "090101",
    id: "B00141RGH5",
    position: ["113.254855", "23.142608"],
  },
  {
    name: "Chinese People's Liberation Army Southern Theatre Air Force Hospital",
    type: "Level 3A",
    level: "General Hospital (Air Force Speciality Related Medicine)",
    parent: "",
    pcode: "440000",
    pname: "Guangdong Province",
    adcode: "440104",
    adname: "Yuexiu District",
    citycode: "020",
    cityname: "Guangzhou City",
    typecode: "120302",
    id: "B0FFF3V087",
    position: ["113.314114", "23.132953"],
  },
  {
    name: "Guangxi Zhuang Autonomous Region People's Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "450000",
    pname: "Guangxi Zhuang Autonomous Region",
    adcode: "450103",
    adname: "Qingxiu District",
    citycode: "0771",
    cityname: "Nanning",
    typecode: "090101",
    id: "B030300767",
    position: ["108.327964", "22.802248"],
  },
  {
    name: "The First Affiliated Hospital of Guangxi Medical University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "450000",
    pname: "Guangxi Zhuang Autonomous Region",
    adcode: "450103",
    adname: "Qingxiu District",
    citycode: "0771",
    cityname: "Nanning",
    typecode: "090101",
    id: "B03030044A",
    position: ["108.343151", "22.795874"],
  },
  {
    name: "The Second Affiliated Hospital of Guangxi Medical University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "450000",
    pname: "Guangxi Zhuang Autonomous Region",
    adcode: "450107",
    adname: "Xixiangtang District",
    citycode: "0771",
    cityname: "Nanning",
    typecode: "090101",
    id: "B0FFHLD7SC",
    position: ["108.259811", "22.841281"],
  },
  {
    name: "Ruikang Hospital, Guangxi University of Traditional Chinese Medicine",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "450000",
    pname: "Guangxi Zhuang Autonomous Region",
    adcode: "450102",
    adname: "Xingning District",
    citycode: "0771",
    cityname: "Nanning",
    typecode: "090101",
    id: "B0303056U6",
    position: ["108.314762", "22.821812"],
  },
  {
    name: "Chinese People's Liberation Army Joint Command and Guarantee Force Ninety-fourth Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "450000",
    pname: "Guangxi Zhuang Autonomous Region",
    adcode: "450304",
    adname: "Elephant Hill District",
    citycode: "0773",
    cityname: "Guilin",
    typecode: "090101",
    id: "B0FFJX8ZRE",
    position: ["110.293958", "25.265328"],
  },
  {
    name: "Chinese People's Liberation Army Joint Logistics Force 923rd Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "450000",
    pname: "Guangxi Zhuang Autonomous Region",
    adcode: "450203",
    adname: "Fishbone District",
    citycode: "0772",
    cityname: "Liuzhou",
    typecode: "130104",
    id: "B03040OIG0",
    position: ["109.429093", "24.282416"],
  },
  {
    name: "The Second Affiliated Hospital of Hainan Medical College",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "460000",
    pname: "Hainan Province",
    adcode: "460106",
    adname: "Longhua District",
    citycode: "0898",
    cityname: "Haikou City",
    typecode: "090101",
    id: "B03820OY4N",
    Position: ["110.300158", "19.979264"],
  },
  {
    name: "Hainan Provincial People's Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "460000",
    pname: "Hainan Province",
    adcode: "460105",
    adname: "Xiuying District",
    citycode: "0898",
    cityname: "Haikou City",
    typecode: "090101",
    id: "B03820OIDK",
    position: ["110.287710", "20.004771"],
  },
  {
    name: "The First Affiliated Hospital of Chongqing Medical University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "500000",
    pname: "Chongqing Municipality",
    adcode: "500103",
    adname: "Yuzhong District",
    citycode: "023",
    cityname: "Chongqing Municipality",
    typecode: "090101",
    id: "B00170L57Q",
    position: ["106.512621", "29.530815"],
  },
  {
    name: "Children's Hospital of Chongqing Medical University",
    type: "Level 3A",
    level: "Specialist hospitals (paediatrics)",
    parent: "",
    pcode: "500000",
    pname: "Chongqing Municipality",
    adcode: "500103",
    adname: "Yuzhong District",
    citycode: "023",
    cityname: "Chongqing Municipality",
    typecode: "090101",
    id: "B00170L1A4",
    position: ["106.554387", "29.556188"],
  },
  {
    name: "The First Affiliated Hospital of the Army Military Medical University of the Chinese People's Liberation Army",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "500000",
    pname: "Chongqing Municipality",
    adcode: "500106",
    adname: "Shapingba District",
    citycode: "023",
    cityname: "Chongqing Municipality",
    typecode: "090101",
    id: "B00170914B",
    position: ["106.452226", "29.536801"],
  },
  {
    name: "The Second Affiliated Hospital of the Army Military Medical University of the Chinese People's Liberation Army",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "500000",
    pname: "Chongqing Municipality",
    adcode: "500103",
    adname: "Yuzhong District",
    citycode: "023",
    cityname: "Chongqing Municipality",
    typecode: "050100",
    id: "B0FFFAJWEQ",
    position: ["106.525912", "29.542336"],
  },
  {
    name: "Chinese People's Liberation Army Army Specialty Medical Centre",
    type: "Level 3A",
    level: "General Hospital",
    parent: "B00178XIWO",
    pcode: "500000",
    pname: "Chongqing Municipality",
    adcode: "500103",
    adname: "Yuzhong District",
    citycode: "023",
    cityname: "Chongqing Municipality",
    typecode: "070000",
    id: "B0FFGBW81E",
    position: ["106.505875", "29.537486"],
  },
  {
    name: "The Second Affiliated Hospital of Chongqing Medical University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "500000",
    pname: "Chongqing Municipality",
    adcode: "500103",
    adname: "Yuzhong District",
    citycode: "023",
    cityname: "Chongqing Municipality",
    typecode: "090101",
    id: "B001791T1I",
    position: ["106.574647", "29.560163"],
  },
  {
    name: "West China Hospital of Sichuan University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "510000",
    pname: "Sichuan Province",
    adcode: "510107",
    adname: "Wuhou District",
    citycode: "028",
    cityname: "Chengdu",
    typecode: "090101",
    id: "B001C05YG2",
    position: ["104.060469", "30.641522"],
  },
  {
    name: "Sichuan Provincial People's Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "B0IB2L08GG",
    pcode: "510000",
    pname: "Sichuan Province",
    adcode: "510105",
    adname: "Qingyang District",
    citycode: "028",
    cityname: "Chengdu",
    typecode: "090101",
    id: "B001C8VGCI",
    position: ["104.040057", "30.662931"],
  },
  {
    name: "General Hospital of the Western Theatre of the Chinese People's Liberation Army",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "510000",
    pname: "Sichuan Province",
    adcode: "510106",
    adname: "Jinniu District",
    citycode: "028",
    cityname: "Chengdu",
    typecode: "190301",
    id: "BZA9N503F4",
    position: ["104.114519", "30.746632"],
  },
  {
    name: "Chinese People's Liberation Army Western Theatre Air Force Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "510000",
    pname: "Sichuan Province",
    adcode: "510107",
    adname: "Wuhou District",
    citycode: "028",
    cityname: "Chengdu",
    typecode: "120302",
    id: "B001C09HNC",
    Position: ["104.058078", "30.615245"],
  },
  {
    name: "Affiliated Hospital of Guizhou Medical University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "520000",
    pname: "Guizhou Province",
    adcode: "520103",
    adname: "Yunyan District",
    citycode: "0851",
    cityname: "Guiyang City",
    typecode: "141201",
    id: "B0FFG38B3H",
    position: ["106.715199", "26.598190"],
  },
  {
    name: "Guizhou Provincial People's Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "520000",
    pname: "Guizhou Province",
    adcode: "520102",
    adname: "Nanming District",
    citycode: "0851",
    cityname: "Guiyang City",
    typecode: "090101",
    id: "B035300VC0",
    position: ["106.722864", "26.576794"],
  },
  {
    name: "Affiliated Hospital of Zunyi Medical University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "520000",
    pname: "Guizhou Province",
    adcode: "520303",
    adname: "Huichuan District",
    citycode: "0852",
    cityname: "Zunyi",
    typecode: "090101",
    id: "B035400HOB",
    position: ["106.945268", "27.706648"],
  },
  {
    name: "The First Affiliated Hospital of Kunming Medical University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "530000",
    pname: "Yunnan Province",
    adcode: "530102",
    adname: "Wuhua District",
    citycode: "0871",
    cityname: "Kunming",
    typecode: "090101",
    id: "B036702A3E",
    position: ["102.693049", "25.042449"],
  },
  {
    name: "Kunming First People's Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "530000",
    pname: "Yunnan Province",
    adcode: "530103",
    adname: "Panlong District",
    citycode: "0871",
    cityname: "Kunming",
    typecode: "090101",
    id: "B03670Z5UW",
    Position: ["102.736568", "25.091715"],
  },
  {
    name: "Tibet Autonomous Region People's Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "540000",
    pname: "Tibet Autonomous Region",
    adcode: "540102",
    adname: "Chengguan District",
    citycode: "0891",
    cityname: "Lhasa",
    typecode: "090101",
    id: "B0FFFX8HQY",
    position: ["91.127083", "29.656341"],
  },
  {
    name: "The First Affiliated Hospital of Xi'an Jiaotong University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "610000",
    pname: "Shaanxi Province",
    adcode: "610113",
    adname: "Yanta District",
    citycode: "029",
    cityname: "Xi'an",
    typecode: "090101",
    id: "B001D08AKU",
    Position: ["108.936741", "34.219569"],
  },
  {
    name: "Shaanxi Provincial People's Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "610000",
    pname: "Shaanxi Province",
    adcode: "610103",
    adname: "Beilin District",
    citycode: "029",
    cityname: "Xi'an",
    typecode: "190301",
    id: "B0FFH6ITJW",
    position: ["108.928750", "34.241136"],
  },
  {
    name: "The First Affiliated Hospital of the Air Force Military Medical University of the People's Liberation Army",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "610000",
    pname: "Shaanxi Province",
    adcode: "610102",
    adname: "New Town",
    citycode: "029",
    cityname: "Xi'an",
    typecode: "110105",
    id: "B0FFFFSUU7",
    position: ["108.988205", "34.270005"],
  },
  {
    name: "The Second Hospital of Lanzhou University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "620000",
    pname: "Gansu Province",
    adcode: "620102",
    adname: "Chengguan District",
    citycode: "0931",
    cityname: "Lanzhou",
    typecode: "090101",
    id: "B03A3032B3",
    position: ["103.812965", "36.061106"],
  },
  {
    name: "Gansu Provincial People's Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "620000",
    pname: "Gansu Province",
    adcode: "620102",
    adname: "Chengguan District",
    citycode: "0931",
    cityname: "Lanzhou",
    typecode: "090101",
    id: "B03A30AKI4",
    Position: ["103.867220", "36.048550"],
  },
  {
    name: "Chinese People's Liberation Army Joint Command and Guarantee Force Ninety-fourth Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "620000",
    pname: "Gansu Province",
    adcode: "620103",
    adname: "Chilihe District",
    citycode: "0931",
    cityname: "Lanzhou",
    typecode: "190301",
    id: "B0FFGRNU3F",
    position: ["103.785285", "36.066813"],
  },
  {
    name: "Qinghai University Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "630000",
    pname: "Qinghai Province",
    adcode: "630104",
    adname: "City West",
    citycode: "0971",
    cityname: "Xining City",
    typecode: "090101",
    id: "B0FFFQ1X4R",
    Position: ["101.763392", "36.623021"],
  },
  {
    name: "Ningxia Hui Autonomous Region People's Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "B03B703QBU",
    pcode: "640000",
    pname: "Ningxia Hui Autonomous Region",
    adcode: "640106",
    adname: "Jinfeng District",
    citycode: "0951",
    cityname: "Yinchuan",
    typecode: "090101",
    id: "B0FFG4RB4Q",
    position: ["106.253409", "38.503823"],
  },
  {
    name: "The First Affiliated Hospital of Xinjiang Medical University",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "650000",
    pname: "Xinjiang Uygur Autonomous Region",
    adcode: "650104",
    adname: "New Downtown",
    citycode: "0991",
    cityname: "Urumqi",
    typecode: "141201",
    id: "B03DF066N4",
    position: ["87.579571", "43.836944"],
  },
  {
    name: "Xinjiang Uygur Autonomous Region People's Hospital",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "650000",
    pname: "Xinjiang Uygur Autonomous Region",
    adcode: "650102",
    adname: "Tien Shan District",
    citycode: "0991",
    cityname: "Urumqi",
    typecode: "090101",
    id: "B03DF04GDA",
    position: ["87.613961", "43.783896"],
  },
  {
    name: "Xinjiang Military Region General Hospital of the Chinese People's Liberation Army",
    type: "Level 3A",
    level: "General Hospital",
    parent: "",
    pcode: "650000",
    pname: "Xinjiang Uygur Autonomous Region",
    adcode: "650103",
    adname: "Shaybak District",
    citycode: "0991",
    cityname: "Urumqi",
    typecode: "120302",
    id: "B03DF06OF2",
    position: ["87.584244", "43.828361"],
  },
];
